/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/ev-emitter/ev-emitter.js":
/*!***********************************************!*\
  !*** ./node_modules/ev-emitter/ev-emitter.js ***!
  \***********************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/**
 * EvEmitter v2.1.1
 * Lil' event emitter
 * MIT License
 */
(function (global, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }
})(typeof window != 'undefined' ? window : this, function () {
  function EvEmitter() {}

  var proto = EvEmitter.prototype;

  proto.on = function (eventName, listener) {
    if (!eventName || !listener) return this; // set events hash

    var events = this._events = this._events || {}; // set listeners array

    var listeners = events[eventName] = events[eventName] || []; // only add once

    if (!listeners.includes(listener)) {
      listeners.push(listener);
    }

    return this;
  };

  proto.once = function (eventName, listener) {
    if (!eventName || !listener) return this; // add event

    this.on(eventName, listener); // set once flag
    // set onceEvents hash

    var onceEvents = this._onceEvents = this._onceEvents || {}; // set onceListeners object

    var onceListeners = onceEvents[eventName] = onceEvents[eventName] || {}; // set flag

    onceListeners[listener] = true;
    return this;
  };

  proto.off = function (eventName, listener) {
    var listeners = this._events && this._events[eventName];
    if (!listeners || !listeners.length) return this;
    var index = listeners.indexOf(listener);

    if (index != -1) {
      listeners.splice(index, 1);
    }

    return this;
  };

  proto.emitEvent = function (eventName, args) {
    var listeners = this._events && this._events[eventName];
    if (!listeners || !listeners.length) return this; // copy over to avoid interference if .off() in listener

    listeners = listeners.slice(0);
    args = args || []; // once stuff

    var onceListeners = this._onceEvents && this._onceEvents[eventName];

    var _iterator = _createForOfIteratorHelper(listeners),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var listener = _step.value;
        var isOnce = onceListeners && onceListeners[listener];

        if (isOnce) {
          // remove listener
          // remove before trigger to prevent recursion
          this.off(eventName, listener); // unset once flag

          delete onceListeners[listener];
        } // trigger listener


        listener.apply(this, args);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return this;
  };

  proto.allOff = function () {
    delete this._events;
    delete this._onceEvents;
    return this;
  };

  return EvEmitter;
});

/***/ }),

/***/ "./node_modules/fizzy-ui-utils/utils.js":
/*!**********************************************!*\
  !*** ./node_modules/fizzy-ui-utils/utils.js ***!
  \**********************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/**
 * Fizzy UI utils v3.0.0
 * MIT license
 */
(function (global, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(global);
  } else {
    // browser global
    global.fizzyUIUtils = factory(global);
  }
})(this, function factory(global) {
  var utils = {}; // ----- extend ----- //
  // extends objects

  utils.extend = function (a, b) {
    return Object.assign(a, b);
  }; // ----- modulo ----- //


  utils.modulo = function (num, div) {
    return (num % div + div) % div;
  }; // ----- makeArray ----- //
  // turn element or nodeList into an array


  utils.makeArray = function (obj) {
    // use object if already an array
    if (Array.isArray(obj)) return obj; // return empty array if undefined or null. #6

    if (obj === null || obj === undefined) return [];
    var isArrayLike = _typeof(obj) == 'object' && typeof obj.length == 'number'; // convert nodeList to array

    if (isArrayLike) return _toConsumableArray(obj); // array of single index

    return [obj];
  }; // ----- removeFrom ----- //


  utils.removeFrom = function (ary, obj) {
    var index = ary.indexOf(obj);

    if (index != -1) {
      ary.splice(index, 1);
    }
  }; // ----- getParent ----- //


  utils.getParent = function (elem, selector) {
    while (elem.parentNode && elem != document.body) {
      elem = elem.parentNode;
      if (elem.matches(selector)) return elem;
    }
  }; // ----- getQueryElement ----- //
  // use element as selector string


  utils.getQueryElement = function (elem) {
    if (typeof elem == 'string') {
      return document.querySelector(elem);
    }

    return elem;
  }; // ----- handleEvent ----- //
  // enable .ontype to trigger from .addEventListener( elem, 'type' )


  utils.handleEvent = function (event) {
    var method = 'on' + event.type;

    if (this[method]) {
      this[method](event);
    }
  }; // ----- filterFindElements ----- //


  utils.filterFindElements = function (elems, selector) {
    // make array of elems
    elems = utils.makeArray(elems);
    return elems // check that elem is an actual element
    .filter(function (elem) {
      return elem instanceof HTMLElement;
    }).reduce(function (ffElems, elem) {
      var _ffElems;

      // add elem if no selector
      if (!selector) {
        ffElems.push(elem);
        return ffElems;
      } // filter & find items if we have a selector
      // filter


      if (elem.matches(selector)) {
        ffElems.push(elem);
      } // find children


      var childElems = elem.querySelectorAll(selector); // concat childElems to filterFound array

      ffElems = (_ffElems = ffElems).concat.apply(_ffElems, _toConsumableArray(childElems));
      return ffElems;
    }, []);
  }; // ----- debounceMethod ----- //


  utils.debounceMethod = function (_class, methodName, threshold) {
    threshold = threshold || 100; // original method

    var method = _class.prototype[methodName];
    var timeoutName = methodName + 'Timeout';

    _class.prototype[methodName] = function () {
      var _this = this;

      clearTimeout(this[timeoutName]);
      var args = arguments;
      this[timeoutName] = setTimeout(function () {
        method.apply(_this, args);
        delete _this[timeoutName];
      }, threshold);
    };
  }; // ----- docReady ----- //


  utils.docReady = function (onDocReady) {
    var readyState = document.readyState;

    if (readyState == 'complete' || readyState == 'interactive') {
      // do async to allow for other scripts to run. metafizzy/flickity#441
      setTimeout(onDocReady);
    } else {
      document.addEventListener('DOMContentLoaded', onDocReady);
    }
  }; // ----- htmlInit ----- //
  // http://bit.ly/3oYLusc


  utils.toDashed = function (str) {
    return str.replace(/(.)([A-Z])/g, function (match, $1, $2) {
      return $1 + '-' + $2;
    }).toLowerCase();
  };

  var console = global.console; // allow user to initialize classes via [data-namespace] or .js-namespace class
  // htmlInit( Widget, 'widgetName' )
  // options are parsed from data-namespace-options

  utils.htmlInit = function (WidgetClass, namespace) {
    utils.docReady(function () {
      var dashedNamespace = utils.toDashed(namespace);
      var dataAttr = 'data-' + dashedNamespace;
      var dataAttrElems = document.querySelectorAll("[".concat(dataAttr, "]"));
      var jQuery = global.jQuery;

      _toConsumableArray(dataAttrElems).forEach(function (elem) {
        var attr = elem.getAttribute(dataAttr);
        var options;

        try {
          options = attr && JSON.parse(attr);
        } catch (error) {
          // log error, do not initialize
          if (console) {
            console.error("Error parsing ".concat(dataAttr, " on ").concat(elem.className, ": ").concat(error));
          }

          return;
        } // initialize


        var instance = new WidgetClass(elem, options); // make available via $().data('namespace')

        if (jQuery) {
          jQuery.data(elem, namespace, instance);
        }
      });
    });
  }; // -----  ----- //


  return utils;
});

/***/ }),

/***/ "./node_modules/flickity/js/add-remove-cell.js":
/*!*****************************************************!*\
  !*** ./node_modules/flickity/js/add-remove-cell.js ***!
  \*****************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

// add, remove cell
(function (window, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(__webpack_require__(/*! ./core */ "./node_modules/flickity/js/core.js"), __webpack_require__(/*! fizzy-ui-utils */ "./node_modules/fizzy-ui-utils/utils.js"));
  } else {
    // browser global
    factory(window.Flickity, window.fizzyUIUtils);
  }
})(typeof window != 'undefined' ? window : this, function factory(Flickity, utils) {
  // append cells to a document fragment
  function getCellsFragment(cells) {
    var fragment = document.createDocumentFragment();
    cells.forEach(function (cell) {
      return fragment.appendChild(cell.element);
    });
    return fragment;
  } // -------------------------- add/remove cell prototype -------------------------- //


  var proto = Flickity.prototype;
  /**
   * Insert, prepend, or append cells
   * @param {[Element, Array, NodeList]} elems - Elements to insert
   * @param {Integer} index - Zero-based number to insert
   */

  proto.insert = function (elems, index) {
    var cells = this._makeCells(elems);

    if (!cells || !cells.length) return;
    var len = this.cells.length; // default to append

    index = index === undefined ? len : index; // add cells with document fragment

    var fragment = getCellsFragment(cells); // append to slider

    var isAppend = index === len;

    if (isAppend) {
      this.slider.appendChild(fragment);
    } else {
      var insertCellElement = this.cells[index].element;
      this.slider.insertBefore(fragment, insertCellElement);
    } // add to this.cells


    if (index === 0) {
      // prepend, add to start
      this.cells = cells.concat(this.cells);
    } else if (isAppend) {
      // append, add to end
      this.cells = this.cells.concat(cells);
    } else {
      // insert in this.cells
      var endCells = this.cells.splice(index, len - index);
      this.cells = this.cells.concat(cells).concat(endCells);
    }

    this._sizeCells(cells);

    this.cellChange(index);
    this.positionSliderAtSelected();
  };

  proto.append = function (elems) {
    this.insert(elems, this.cells.length);
  };

  proto.prepend = function (elems) {
    this.insert(elems, 0);
  };
  /**
   * Remove cells
   * @param {[Element, Array, NodeList]} elems - ELements to remove
   */


  proto.remove = function (elems) {
    var _this = this;

    var cells = this.getCells(elems);
    if (!cells || !cells.length) return;
    var minCellIndex = this.cells.length - 1; // remove cells from collection & DOM

    cells.forEach(function (cell) {
      cell.remove();

      var index = _this.cells.indexOf(cell);

      minCellIndex = Math.min(index, minCellIndex);
      utils.removeFrom(_this.cells, cell);
    });
    this.cellChange(minCellIndex);
    this.positionSliderAtSelected();
  };
  /**
   * logic to be run after a cell's size changes
   * @param {Element} elem - cell's element
   */


  proto.cellSizeChange = function (elem) {
    var cell = this.getCell(elem);
    if (!cell) return;
    cell.getSize();
    var index = this.cells.indexOf(cell);
    this.cellChange(index); // do not position slider after lazy load
  };
  /**
   * logic any time a cell is changed: added, removed, or size changed
   * @param {Integer} changedCellIndex - index of the changed cell, optional
   */


  proto.cellChange = function (changedCellIndex) {
    var prevSelectedElem = this.selectedElement;

    this._positionCells(changedCellIndex);

    this._updateWrapShiftCells();

    this.setGallerySize(); // update selectedIndex, try to maintain position & select previous selected element

    var cell = this.getCell(prevSelectedElem);
    if (cell) this.selectedIndex = this.getCellSlideIndex(cell);
    this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);
    this.emitEvent('cellChange', [changedCellIndex]); // position slider

    this.select(this.selectedIndex);
  }; // -----  ----- //


  return Flickity;
});

/***/ }),

/***/ "./node_modules/flickity/js/animate.js":
/*!*********************************************!*\
  !*** ./node_modules/flickity/js/animate.js ***!
  \*********************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

// animate
(function (window, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(__webpack_require__(/*! fizzy-ui-utils */ "./node_modules/fizzy-ui-utils/utils.js"));
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.animatePrototype = factory(window.fizzyUIUtils);
  }
})(typeof window != 'undefined' ? window : this, function factory(utils) {
  // -------------------------- animate -------------------------- //
  var proto = {};

  proto.startAnimation = function () {
    if (this.isAnimating) return;
    this.isAnimating = true;
    this.restingFrames = 0;
    this.animate();
  };

  proto.animate = function () {
    var _this = this;

    this.applyDragForce();
    this.applySelectedAttraction();
    var previousX = this.x;
    this.integratePhysics();
    this.positionSlider();
    this.settle(previousX); // animate next frame

    if (this.isAnimating) requestAnimationFrame(function () {
      return _this.animate();
    });
  };

  proto.positionSlider = function () {
    var x = this.x; // wrap position around

    if (this.isWrapping) {
      x = utils.modulo(x, this.slideableWidth) - this.slideableWidth;
      this.shiftWrapCells(x);
    }

    this.setTranslateX(x, this.isAnimating);
    this.dispatchScrollEvent();
  };

  proto.setTranslateX = function (x, is3d) {
    x += this.cursorPosition; // reverse if right-to-left and using transform

    if (this.options.rightToLeft) x = -x;
    var translateX = this.getPositionValue(x); // use 3D transforms for hardware acceleration on iOS
    // but use 2D when settled, for better font-rendering

    this.slider.style.transform = is3d ? "translate3d(".concat(translateX, ",0,0)") : "translateX(".concat(translateX, ")");
  };

  proto.dispatchScrollEvent = function () {
    var firstSlide = this.slides[0];
    if (!firstSlide) return;
    var positionX = -this.x - firstSlide.target;
    var progress = positionX / this.slidesWidth;
    this.dispatchEvent('scroll', null, [progress, positionX]);
  };

  proto.positionSliderAtSelected = function () {
    if (!this.cells.length) return;
    this.x = -this.selectedSlide.target;
    this.velocity = 0; // stop wobble

    this.positionSlider();
  };

  proto.getPositionValue = function (position) {
    if (this.options.percentPosition) {
      // percent position, round to 2 digits, like 12.34%
      return Math.round(position / this.size.innerWidth * 10000) * 0.01 + '%';
    } else {
      // pixel positioning
      return Math.round(position) + 'px';
    }
  };

  proto.settle = function (previousX) {
    // keep track of frames where x hasn't moved
    var isResting = !this.isPointerDown && Math.round(this.x * 100) === Math.round(previousX * 100);
    if (isResting) this.restingFrames++; // stop animating if resting for 3 or more frames

    if (this.restingFrames > 2) {
      this.isAnimating = false;
      delete this.isFreeScrolling; // render position with translateX when settled

      this.positionSlider();
      this.dispatchEvent('settle', null, [this.selectedIndex]);
    }
  };

  proto.shiftWrapCells = function (x) {
    // shift before cells
    var beforeGap = this.cursorPosition + x;

    this._shiftCells(this.beforeShiftCells, beforeGap, -1); // shift after cells


    var afterGap = this.size.innerWidth - (x + this.slideableWidth + this.cursorPosition);

    this._shiftCells(this.afterShiftCells, afterGap, 1);
  };

  proto._shiftCells = function (cells, gap, shift) {
    var _this2 = this;

    cells.forEach(function (cell) {
      var cellShift = gap > 0 ? shift : 0;

      _this2._wrapShiftCell(cell, cellShift);

      gap -= cell.size.outerWidth;
    });
  };

  proto._unshiftCells = function (cells) {
    var _this3 = this;

    if (!cells || !cells.length) return;
    cells.forEach(function (cell) {
      return _this3._wrapShiftCell(cell, 0);
    });
  }; // @param {Integer} shift - 0, 1, or -1


  proto._wrapShiftCell = function (cell, shift) {
    this._renderCellPosition(cell, cell.x + this.slideableWidth * shift);
  }; // -------------------------- physics -------------------------- //


  proto.integratePhysics = function () {
    this.x += this.velocity;
    this.velocity *= this.getFrictionFactor();
  };

  proto.applyForce = function (force) {
    this.velocity += force;
  };

  proto.getFrictionFactor = function () {
    return 1 - this.options[this.isFreeScrolling ? 'freeScrollFriction' : 'friction'];
  };

  proto.getRestingPosition = function () {
    // my thanks to Steven Wittens, who simplified this math greatly
    return this.x + this.velocity / (1 - this.getFrictionFactor());
  };

  proto.applyDragForce = function () {
    if (!this.isDraggable || !this.isPointerDown) return; // change the position to drag position by applying force

    var dragVelocity = this.dragX - this.x;
    var dragForce = dragVelocity - this.velocity;
    this.applyForce(dragForce);
  };

  proto.applySelectedAttraction = function () {
    // do not attract if pointer down or no slides
    var dragDown = this.isDraggable && this.isPointerDown;
    if (dragDown || this.isFreeScrolling || !this.slides.length) return;
    var distance = this.selectedSlide.target * -1 - this.x;
    var force = distance * this.options.selectedAttraction;
    this.applyForce(force);
  };

  return proto;
});

/***/ }),

/***/ "./node_modules/flickity/js/cell.js":
/*!******************************************!*\
  !*** ./node_modules/flickity/js/cell.js ***!
  \******************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

// Flickity.Cell
(function (window, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(__webpack_require__(/*! get-size */ "./node_modules/get-size/get-size.js"));
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.Cell = factory(window.getSize);
  }
})(typeof window != 'undefined' ? window : this, function factory(getSize) {
  var cellClassName = 'flickity-cell';

  function Cell(elem) {
    this.element = elem;
    this.element.classList.add(cellClassName);
    this.x = 0;
    this.unselect();
  }

  var proto = Cell.prototype;

  proto.destroy = function () {
    // reset style
    this.unselect();
    this.element.classList.remove(cellClassName);
    this.element.style.transform = '';
    this.element.removeAttribute('aria-hidden');
  };

  proto.getSize = function () {
    this.size = getSize(this.element);
  };

  proto.select = function () {
    this.element.classList.add('is-selected');
    this.element.removeAttribute('aria-hidden');
  };

  proto.unselect = function () {
    this.element.classList.remove('is-selected');
    this.element.setAttribute('aria-hidden', 'true');
  };

  proto.remove = function () {
    this.element.remove();
  };

  return Cell;
});

/***/ }),

/***/ "./node_modules/flickity/js/core.js":
/*!******************************************!*\
  !*** ./node_modules/flickity/js/core.js ***!
  \******************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

// Flickity main

/* eslint-disable max-params */
(function (window, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, __webpack_require__(/*! ev-emitter */ "./node_modules/ev-emitter/ev-emitter.js"), __webpack_require__(/*! get-size */ "./node_modules/get-size/get-size.js"), __webpack_require__(/*! fizzy-ui-utils */ "./node_modules/fizzy-ui-utils/utils.js"), __webpack_require__(/*! ./cell */ "./node_modules/flickity/js/cell.js"), __webpack_require__(/*! ./slide */ "./node_modules/flickity/js/slide.js"), __webpack_require__(/*! ./animate */ "./node_modules/flickity/js/animate.js"));
  } else {
    // browser global
    var _Flickity = window.Flickity;
    window.Flickity = factory(window, window.EvEmitter, window.getSize, window.fizzyUIUtils, _Flickity.Cell, _Flickity.Slide, _Flickity.animatePrototype);
  }
})(typeof window != 'undefined' ? window : this, function factory(window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
  /* eslint-enable max-params */
  // vars
  var getComputedStyle = window.getComputedStyle,
      console = window.console;
  var jQuery = window.jQuery; // -------------------------- Flickity -------------------------- //
  // globally unique identifiers

  var GUID = 0; // internal store of all Flickity intances

  var instances = {};

  function Flickity(element, options) {
    var queryElement = utils.getQueryElement(element);

    if (!queryElement) {
      if (console) console.error("Bad element for Flickity: ".concat(queryElement || element));
      return;
    }

    this.element = queryElement; // do not initialize twice on same element

    if (this.element.flickityGUID) {
      var instance = instances[this.element.flickityGUID];
      if (instance) instance.option(options);
      return instance;
    } // add jQuery


    if (jQuery) {
      this.$element = jQuery(this.element);
    } // options


    this.options = _objectSpread({}, this.constructor.defaults);
    this.option(options); // kick things off

    this._create();
  }

  Flickity.defaults = {
    accessibility: true,
    // adaptiveHeight: false,
    cellAlign: 'center',
    // cellSelector: undefined,
    // contain: false,
    freeScrollFriction: 0.075,
    // friction when free-scrolling
    friction: 0.28,
    // friction when selecting
    namespaceJQueryEvents: true,
    // initialIndex: 0,
    percentPosition: true,
    resize: true,
    selectedAttraction: 0.025,
    setGallerySize: true // watchCSS: false,
    // wrapAround: false

  }; // hash of methods triggered on _create()

  Flickity.create = {};
  var proto = Flickity.prototype; // inherit EventEmitter

  Object.assign(proto, EvEmitter.prototype);

  proto._create = function () {
    var _this$options = this.options,
        resize = _this$options.resize,
        watchCSS = _this$options.watchCSS,
        rightToLeft = _this$options.rightToLeft; // add id for Flickity.data

    var id = this.guid = ++GUID;
    this.element.flickityGUID = id; // expando

    instances[id] = this; // associate via id
    // initial properties

    this.selectedIndex = 0; // how many frames slider has been in same position

    this.restingFrames = 0; // initial physics properties

    this.x = 0;
    this.velocity = 0;
    this.beginMargin = rightToLeft ? 'marginRight' : 'marginLeft';
    this.endMargin = rightToLeft ? 'marginLeft' : 'marginRight'; // create viewport & slider

    this.viewport = document.createElement('div');
    this.viewport.className = 'flickity-viewport';

    this._createSlider(); // used for keyboard navigation


    this.focusableElems = [this.element];

    if (resize || watchCSS) {
      window.addEventListener('resize', this);
    } // add listeners from on option


    for (var eventName in this.options.on) {
      var listener = this.options.on[eventName];
      this.on(eventName, listener);
    }

    for (var method in Flickity.create) {
      Flickity.create[method].call(this);
    }

    if (watchCSS) {
      this.watchCSS();
    } else {
      this.activate();
    }
  };
  /**
   * set options
   * @param {Object} opts - options to extend
   */


  proto.option = function (opts) {
    Object.assign(this.options, opts);
  };

  proto.activate = function () {
    var _this$slider;

    if (this.isActive) return;
    this.isActive = true;
    this.element.classList.add('flickity-enabled');

    if (this.options.rightToLeft) {
      this.element.classList.add('flickity-rtl');
    }

    this.getSize(); // move initial cell elements so they can be loaded as cells

    var cellElems = this._filterFindCellElements(this.element.children);

    (_this$slider = this.slider).append.apply(_this$slider, _toConsumableArray(cellElems));

    this.viewport.append(this.slider);
    this.element.append(this.viewport); // get cells from children

    this.reloadCells();

    if (this.options.accessibility) {
      // allow element to focusable
      this.element.tabIndex = 0; // listen for key presses

      this.element.addEventListener('keydown', this);
    }

    this.emitEvent('activate');
    this.selectInitialIndex(); // flag for initial activation, for using initialIndex

    this.isInitActivated = true; // ready event. #493

    this.dispatchEvent('ready');
  }; // slider positions the cells


  proto._createSlider = function () {
    // slider element does all the positioning
    var slider = document.createElement('div');
    slider.className = 'flickity-slider';
    this.slider = slider;
  };

  proto._filterFindCellElements = function (elems) {
    return utils.filterFindElements(elems, this.options.cellSelector);
  }; // goes through all children


  proto.reloadCells = function () {
    // collection of item elements
    this.cells = this._makeCells(this.slider.children);
    this.positionCells();

    this._updateWrapShiftCells();

    this.setGallerySize();
  };
  /**
   * turn elements into Flickity.Cells
   * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
   * @returns {Array} items - collection of new Flickity Cells
   */


  proto._makeCells = function (elems) {
    var cellElems = this._filterFindCellElements(elems); // create new Cells for collection


    return cellElems.map(function (cellElem) {
      return new Cell(cellElem);
    });
  };

  proto.getLastCell = function () {
    return this.cells[this.cells.length - 1];
  };

  proto.getLastSlide = function () {
    return this.slides[this.slides.length - 1];
  }; // positions all cells


  proto.positionCells = function () {
    // size all cells
    this._sizeCells(this.cells); // position all cells


    this._positionCells(0);
  };
  /**
   * position certain cells
   * @param {Integer} index - which cell to start with
   */


  proto._positionCells = function (index) {
    var _this = this;

    index = index || 0; // also measure maxCellHeight
    // start 0 if positioning all cells

    this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
    var cellX = 0; // get cellX

    if (index > 0) {
      var startCell = this.cells[index - 1];
      cellX = startCell.x + startCell.size.outerWidth;
    }

    this.cells.slice(index).forEach(function (cell) {
      cell.x = cellX;

      _this._renderCellPosition(cell, cellX);

      cellX += cell.size.outerWidth;
      _this.maxCellHeight = Math.max(cell.size.outerHeight, _this.maxCellHeight);
    }); // keep track of cellX for wrap-around

    this.slideableWidth = cellX; // slides

    this.updateSlides(); // contain slides target

    this._containSlides(); // update slidesWidth


    this.slidesWidth = this.cells.length ? this.getLastSlide().target - this.slides[0].target : 0;
  };

  proto._renderCellPosition = function (cell, x) {
    // render position of cell with in slider
    var sideOffset = this.options.rightToLeft ? -1 : 1;
    var renderX = x * sideOffset;
    if (this.options.percentPosition) renderX *= this.size.innerWidth / cell.size.width;
    var positionValue = this.getPositionValue(renderX);
    cell.element.style.transform = "translateX( ".concat(positionValue, " )");
  };
  /**
   * cell.getSize() on multiple cells
   * @param {Array} cells - cells to size
   */


  proto._sizeCells = function (cells) {
    cells.forEach(function (cell) {
      return cell.getSize();
    });
  }; // --------------------------  -------------------------- //


  proto.updateSlides = function () {
    var _this2 = this;

    this.slides = [];
    if (!this.cells.length) return;
    var beginMargin = this.beginMargin,
        endMargin = this.endMargin;
    var slide = new Slide(beginMargin, endMargin, this.cellAlign);
    this.slides.push(slide);

    var canCellFit = this._getCanCellFit();

    this.cells.forEach(function (cell, i) {
      // just add cell if first cell in slide
      if (!slide.cells.length) {
        slide.addCell(cell);
        return;
      }

      var slideWidth = slide.outerWidth - slide.firstMargin + (cell.size.outerWidth - cell.size[endMargin]);

      if (canCellFit(i, slideWidth)) {
        slide.addCell(cell);
      } else {
        // doesn't fit, new slide
        slide.updateTarget();
        slide = new Slide(beginMargin, endMargin, _this2.cellAlign);

        _this2.slides.push(slide);

        slide.addCell(cell);
      }
    }); // last slide

    slide.updateTarget(); // update .selectedSlide

    this.updateSelectedSlide();
  };

  proto._getCanCellFit = function () {
    var groupCells = this.options.groupCells;
    if (!groupCells) return function () {
      return false;
    };

    if (typeof groupCells == 'number') {
      // group by number. 3 -> [0,1,2], [3,4,5], ...
      var number = parseInt(groupCells, 10);
      return function (i) {
        return i % number !== 0;
      };
    } // default, group by width of slide


    var percent = 1; // parse '75%

    var percentMatch = typeof groupCells == 'string' && groupCells.match(/^(\d+)%$/);
    if (percentMatch) percent = parseInt(percentMatch[1], 10) / 100;
    var groupWidth = (this.size.innerWidth + 1) * percent;
    return function (i, slideWidth) {
      return slideWidth <= groupWidth;
    };
  }; // alias _init for jQuery plugin .flickity()


  proto._init = proto.reposition = function () {
    this.positionCells();
    this.positionSliderAtSelected();
  };

  proto.getSize = function () {
    this.size = getSize(this.element);
    this.setCellAlign();
    this.cursorPosition = this.size.innerWidth * this.cellAlign;
  };

  var cellAlignShorthands = {
    left: 0,
    center: 0.5,
    right: 1
  };

  proto.setCellAlign = function () {
    var _this$options2 = this.options,
        cellAlign = _this$options2.cellAlign,
        rightToLeft = _this$options2.rightToLeft;
    var shorthand = cellAlignShorthands[cellAlign];
    this.cellAlign = shorthand !== undefined ? shorthand : cellAlign;
    if (rightToLeft) this.cellAlign = 1 - this.cellAlign;
  };

  proto.setGallerySize = function () {
    if (!this.options.setGallerySize) return;
    var height = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
    this.viewport.style.height = "".concat(height, "px");
  };

  proto._updateWrapShiftCells = function () {
    // update isWrapping
    this.isWrapping = this.getIsWrapping(); // only for wrap-around

    if (!this.isWrapping) return; // unshift previous cells

    this._unshiftCells(this.beforeShiftCells);

    this._unshiftCells(this.afterShiftCells); // get before cells
    // initial gap


    var beforeGapX = this.cursorPosition;
    var lastIndex = this.cells.length - 1;
    this.beforeShiftCells = this._getGapCells(beforeGapX, lastIndex, -1); // get after cells
    // ending gap between last cell and end of gallery viewport

    var afterGapX = this.size.innerWidth - this.cursorPosition; // start cloning at first cell, working forwards

    this.afterShiftCells = this._getGapCells(afterGapX, 0, 1);
  };

  proto.getIsWrapping = function () {
    var wrapAround = this.options.wrapAround;
    if (!wrapAround || this.slides.length < 2) return false;
    if (wrapAround !== 'fill') return true; // check that slides can fit

    var gapWidth = this.slideableWidth - this.size.innerWidth;
    if (gapWidth > this.size.innerWidth) return true; // gap * 2x big, all good
    // check that content width - shifting cell is bigger than viewport width

    var _iterator = _createForOfIteratorHelper(this.cells),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var cell = _step.value;
        if (cell.size.outerWidth > gapWidth) return false;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return true;
  };

  proto._getGapCells = function (gapX, cellIndex, increment) {
    // keep adding cells until the cover the initial gap
    var cells = [];

    while (gapX > 0) {
      var cell = this.cells[cellIndex];
      if (!cell) break;
      cells.push(cell);
      cellIndex += increment;
      gapX -= cell.size.outerWidth;
    }

    return cells;
  }; // ----- contain & wrap ----- //
  // contain cell targets so no excess sliding


  proto._containSlides = function () {
    var _this3 = this;

    var isContaining = this.options.contain && !this.isWrapping && this.cells.length;
    if (!isContaining) return;
    var contentWidth = this.slideableWidth - this.getLastCell().size[this.endMargin]; // content is less than gallery size

    var isContentSmaller = contentWidth < this.size.innerWidth;

    if (isContentSmaller) {
      // all cells fit inside gallery
      this.slides.forEach(function (slide) {
        slide.target = contentWidth * _this3.cellAlign;
      });
    } else {
      // contain to bounds
      var beginBound = this.cursorPosition + this.cells[0].size[this.beginMargin];
      var endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign);
      this.slides.forEach(function (slide) {
        slide.target = Math.max(slide.target, beginBound);
        slide.target = Math.min(slide.target, endBound);
      });
    }
  }; // ----- events ----- //

  /**
   * emits events via eventEmitter and jQuery events
   * @param {String} type - name of event
   * @param {Event} event - original event
   * @param {Array} args - extra arguments
   */


  proto.dispatchEvent = function (type, event, args) {
    var emitArgs = event ? [event].concat(args) : args;
    this.emitEvent(type, emitArgs);

    if (jQuery && this.$element) {
      // default trigger with type if no event
      type += this.options.namespaceJQueryEvents ? '.flickity' : '';
      var $event = type;

      if (event) {
        // create jQuery event
        var jQEvent = new jQuery.Event(event);
        jQEvent.type = type;
        $event = jQEvent;
      }

      this.$element.trigger($event, args);
    }
  };

  var unidraggerEvents = ['dragStart', 'dragMove', 'dragEnd', 'pointerDown', 'pointerMove', 'pointerEnd', 'staticClick'];
  var _emitEvent = proto.emitEvent;

  proto.emitEvent = function (eventName, args) {
    if (eventName === 'staticClick') {
      // add cellElem and cellIndex args to staticClick
      var clickedCell = this.getParentCell(args[0].target);
      var cellElem = clickedCell && clickedCell.element;
      var cellIndex = clickedCell && this.cells.indexOf(clickedCell);
      args = args.concat(cellElem, cellIndex);
    } // do regular thing


    _emitEvent.call(this, eventName, args); // duck-punch in jQuery events for Unidragger events


    var isUnidraggerEvent = unidraggerEvents.includes(eventName);
    if (!isUnidraggerEvent || !jQuery || !this.$element) return;
    eventName += this.options.namespaceJQueryEvents ? '.flickity' : '';
    var event = args.shift(0);
    var jQEvent = new jQuery.Event(event);
    jQEvent.type = eventName;
    this.$element.trigger(jQEvent, args);
  }; // -------------------------- select -------------------------- //

  /**
   * @param {Integer} index - index of the slide
   * @param {Boolean} isWrap - will wrap-around to last/first if at the end
   * @param {Boolean} isInstant - will immediately set position at selected cell
   */


  proto.select = function (index, isWrap, isInstant) {
    if (!this.isActive) return;
    index = parseInt(index, 10);

    this._wrapSelect(index);

    if (this.isWrapping || isWrap) {
      index = utils.modulo(index, this.slides.length);
    } // bail if invalid index


    if (!this.slides[index]) return;
    var prevIndex = this.selectedIndex;
    this.selectedIndex = index;
    this.updateSelectedSlide();

    if (isInstant) {
      this.positionSliderAtSelected();
    } else {
      this.startAnimation();
    }

    if (this.options.adaptiveHeight) {
      this.setGallerySize();
    } // events


    this.dispatchEvent('select', null, [index]); // change event if new index

    if (index !== prevIndex) {
      this.dispatchEvent('change', null, [index]);
    }
  }; // wraps position for wrapAround, to move to closest slide. #113


  proto._wrapSelect = function (index) {
    if (!this.isWrapping) return;
    var selectedIndex = this.selectedIndex,
        slideableWidth = this.slideableWidth,
        length = this.slides.length; // shift index for wrap, do not wrap dragSelect

    if (!this.isDragSelect) {
      var wrapIndex = utils.modulo(index, length); // go to shortest

      var delta = Math.abs(wrapIndex - selectedIndex);
      var backWrapDelta = Math.abs(wrapIndex + length - selectedIndex);
      var forewardWrapDelta = Math.abs(wrapIndex - length - selectedIndex);

      if (backWrapDelta < delta) {
        index += length;
      } else if (forewardWrapDelta < delta) {
        index -= length;
      }
    } // wrap position so slider is within normal area


    if (index < 0) {
      this.x -= slideableWidth;
    } else if (index >= length) {
      this.x += slideableWidth;
    }
  };

  proto.previous = function (isWrap, isInstant) {
    this.select(this.selectedIndex - 1, isWrap, isInstant);
  };

  proto.next = function (isWrap, isInstant) {
    this.select(this.selectedIndex + 1, isWrap, isInstant);
  };

  proto.updateSelectedSlide = function () {
    var slide = this.slides[this.selectedIndex]; // selectedIndex could be outside of slides, if triggered before resize()

    if (!slide) return; // unselect previous selected slide

    this.unselectSelectedSlide(); // update new selected slide

    this.selectedSlide = slide;
    slide.select();
    this.selectedCells = slide.cells;
    this.selectedElements = slide.getCellElements(); // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility

    this.selectedCell = slide.cells[0];
    this.selectedElement = this.selectedElements[0];
  };

  proto.unselectSelectedSlide = function () {
    if (this.selectedSlide) this.selectedSlide.unselect();
  };

  proto.selectInitialIndex = function () {
    var initialIndex = this.options.initialIndex; // already activated, select previous selectedIndex

    if (this.isInitActivated) {
      this.select(this.selectedIndex, false, true);
      return;
    } // select with selector string


    if (initialIndex && typeof initialIndex == 'string') {
      var cell = this.queryCell(initialIndex);

      if (cell) {
        this.selectCell(initialIndex, false, true);
        return;
      }
    }

    var index = 0; // select with number

    if (initialIndex && this.slides[initialIndex]) {
      index = initialIndex;
    } // select instantly


    this.select(index, false, true);
  };
  /**
   * select slide from number or cell element
   * @param {[Element, Number]} value - zero-based index or element to select
   * @param {Boolean} isWrap - enables wrapping around for extra index
   * @param {Boolean} isInstant - disables slide animation
   */


  proto.selectCell = function (value, isWrap, isInstant) {
    // get cell
    var cell = this.queryCell(value);
    if (!cell) return;
    var index = this.getCellSlideIndex(cell);
    this.select(index, isWrap, isInstant);
  };

  proto.getCellSlideIndex = function (cell) {
    // get index of slide that has cell
    var cellSlide = this.slides.find(function (slide) {
      return slide.cells.includes(cell);
    });
    return this.slides.indexOf(cellSlide);
  }; // -------------------------- get cells -------------------------- //

  /**
   * get Flickity.Cell, given an Element
   * @param {Element} elem - matching cell element
   * @returns {Flickity.Cell} cell - matching cell
   */


  proto.getCell = function (elem) {
    // loop through cells to get the one that matches
    var _iterator2 = _createForOfIteratorHelper(this.cells),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var cell = _step2.value;
        if (cell.element === elem) return cell;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  };
  /**
   * get collection of Flickity.Cells, given Elements
   * @param {[Element, Array, NodeList]} elems - multiple elements
   * @returns {Array} cells - Flickity.Cells
   */


  proto.getCells = function (elems) {
    var _this4 = this;

    elems = utils.makeArray(elems);
    return elems.map(function (elem) {
      return _this4.getCell(elem);
    }).filter(Boolean);
  };
  /**
   * get cell elements
   * @returns {Array} cellElems
   */


  proto.getCellElements = function () {
    return this.cells.map(function (cell) {
      return cell.element;
    });
  };
  /**
   * get parent cell from an element
   * @param {Element} elem - child element
   * @returns {Flickit.Cell} cell - parent cell
   */


  proto.getParentCell = function (elem) {
    // first check if elem is cell
    var cell = this.getCell(elem);
    if (cell) return cell; // try to get parent cell elem

    var closest = elem.closest('.flickity-slider > *');
    return this.getCell(closest);
  };
  /**
   * get cells adjacent to a slide
   * @param {Integer} adjCount - number of adjacent slides
   * @param {Integer} index - index of slide to start
   * @returns {Array} cells - array of Flickity.Cells
   */


  proto.getAdjacentCellElements = function (adjCount, index) {
    if (!adjCount) return this.selectedSlide.getCellElements();
    index = index === undefined ? this.selectedIndex : index;
    var len = this.slides.length;

    if (1 + adjCount * 2 >= len) {
      return this.getCellElements(); // get all
    }

    var cellElems = [];

    for (var i = index - adjCount; i <= index + adjCount; i++) {
      var slideIndex = this.isWrapping ? utils.modulo(i, len) : i;
      var slide = this.slides[slideIndex];

      if (slide) {
        cellElems = cellElems.concat(slide.getCellElements());
      }
    }

    return cellElems;
  };
  /**
   * select slide from number or cell element
   * @param {[Element, String, Number]} selector - element, selector string, or index
   * @returns {Flickity.Cell} - matching cell
   */


  proto.queryCell = function (selector) {
    if (typeof selector == 'number') {
      // use number as index
      return this.cells[selector];
    } // do not select invalid selectors from hash: #123, #/. #791


    var isSelectorString = typeof selector == 'string' && !selector.match(/^[#.]?[\d/]/);

    if (isSelectorString) {
      // use string as selector, get element
      selector = this.element.querySelector(selector);
    } // get cell from element


    return this.getCell(selector);
  }; // -------------------------- events -------------------------- //


  proto.uiChange = function () {
    this.emitEvent('uiChange');
  }; // ----- resize ----- //


  proto.onresize = function () {
    this.watchCSS();
    this.resize();
  };

  utils.debounceMethod(Flickity, 'onresize', 150);

  proto.resize = function () {
    // #1177 disable resize behavior when animating or dragging for iOS 15
    if (!this.isActive || this.isAnimating || this.isDragging) return;
    this.getSize(); // wrap values

    if (this.isWrapping) {
      this.x = utils.modulo(this.x, this.slideableWidth);
    }

    this.positionCells();

    this._updateWrapShiftCells();

    this.setGallerySize();
    this.emitEvent('resize'); // update selected index for group slides, instant
    // TODO: position can be lost between groups of various numbers

    var selectedElement = this.selectedElements && this.selectedElements[0];
    this.selectCell(selectedElement, false, true);
  }; // watches the :after property, activates/deactivates


  proto.watchCSS = function () {
    if (!this.options.watchCSS) return;
    var afterContent = getComputedStyle(this.element, ':after').content; // activate if :after { content: 'flickity' }

    if (afterContent.includes('flickity')) {
      this.activate();
    } else {
      this.deactivate();
    }
  }; // ----- keydown ----- //
  // go previous/next if left/right keys pressed


  proto.onkeydown = function (event) {
    var _document = document,
        activeElement = _document.activeElement;
    var handler = Flickity.keyboardHandlers[event.key]; // only work if element is in focus

    if (!this.options.accessibility || !activeElement || !handler) return;
    var isFocused = this.focusableElems.some(function (elem) {
      return activeElement === elem;
    });
    if (isFocused) handler.call(this);
  };

  Flickity.keyboardHandlers = {
    ArrowLeft: function ArrowLeft() {
      this.uiChange();
      var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
      this[leftMethod]();
    },
    ArrowRight: function ArrowRight() {
      this.uiChange();
      var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
      this[rightMethod]();
    }
  }; // ----- focus ----- //

  proto.focus = function () {
    this.element.focus({
      preventScroll: true
    });
  }; // -------------------------- destroy -------------------------- //
  // deactivate all Flickity functionality, but keep stuff available


  proto.deactivate = function () {
    var _this$element;

    if (!this.isActive) return;
    this.element.classList.remove('flickity-enabled');
    this.element.classList.remove('flickity-rtl');
    this.unselectSelectedSlide(); // destroy cells

    this.cells.forEach(function (cell) {
      return cell.destroy();
    });
    this.viewport.remove(); // move child elements back into element

    (_this$element = this.element).append.apply(_this$element, _toConsumableArray(this.slider.children));

    if (this.options.accessibility) {
      this.element.removeAttribute('tabIndex');
      this.element.removeEventListener('keydown', this);
    } // set flags


    this.isActive = false;
    this.emitEvent('deactivate');
  };

  proto.destroy = function () {
    this.deactivate();
    window.removeEventListener('resize', this);
    this.allOff();
    this.emitEvent('destroy');

    if (jQuery && this.$element) {
      jQuery.removeData(this.element, 'flickity');
    }

    delete this.element.flickityGUID;
    delete instances[this.guid];
  }; // -------------------------- prototype -------------------------- //


  Object.assign(proto, animatePrototype); // -------------------------- extras -------------------------- //

  /**
   * get Flickity instance from element
   * @param {[Element, String]} elem - element or selector string
   * @returns {Flickity} - Flickity instance
   */

  Flickity.data = function (elem) {
    elem = utils.getQueryElement(elem);
    if (elem) return instances[elem.flickityGUID];
  };

  utils.htmlInit(Flickity, 'flickity');
  var jQueryBridget = window.jQueryBridget;

  if (jQuery && jQueryBridget) {
    jQueryBridget('flickity', Flickity, jQuery);
  } // set internal jQuery, for Webpack + jQuery v3, #478


  Flickity.setJQuery = function (jq) {
    jQuery = jq;
  };

  Flickity.Cell = Cell;
  Flickity.Slide = Slide;
  return Flickity;
});

/***/ }),

/***/ "./node_modules/flickity/js/drag.js":
/*!******************************************!*\
  !*** ./node_modules/flickity/js/drag.js ***!
  \******************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

// drag
(function (window, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, __webpack_require__(/*! ./core */ "./node_modules/flickity/js/core.js"), __webpack_require__(/*! unidragger */ "./node_modules/unidragger/unidragger.js"), __webpack_require__(/*! fizzy-ui-utils */ "./node_modules/fizzy-ui-utils/utils.js"));
  } else {
    // browser global
    window.Flickity = factory(window, window.Flickity, window.Unidragger, window.fizzyUIUtils);
  }
})(typeof window != 'undefined' ? window : this, function factory(window, Flickity, Unidragger, utils) {
  // ----- defaults ----- //
  Object.assign(Flickity.defaults, {
    draggable: '>1',
    dragThreshold: 3
  }); // -------------------------- drag prototype -------------------------- //

  var proto = Flickity.prototype;
  Object.assign(proto, Unidragger.prototype); // inherit Unidragger

  proto.touchActionValue = ''; // --------------------------  -------------------------- //

  Flickity.create.drag = function () {
    this.on('activate', this.onActivateDrag);
    this.on('uiChange', this._uiChangeDrag);
    this.on('deactivate', this.onDeactivateDrag);
    this.on('cellChange', this.updateDraggable);
    this.on('pointerDown', this.handlePointerDown);
    this.on('pointerUp', this.handlePointerUp);
    this.on('pointerDown', this.handlePointerDone);
    this.on('dragStart', this.handleDragStart);
    this.on('dragMove', this.handleDragMove);
    this.on('dragEnd', this.handleDragEnd);
    this.on('staticClick', this.handleStaticClick); // TODO updateDraggable on resize? if groupCells & slides change
  };

  proto.onActivateDrag = function () {
    this.handles = [this.viewport];
    this.bindHandles();
    this.updateDraggable();
  };

  proto.onDeactivateDrag = function () {
    this.unbindHandles();
    this.element.classList.remove('is-draggable');
  };

  proto.updateDraggable = function () {
    // disable dragging if less than 2 slides. #278
    if (this.options.draggable === '>1') {
      this.isDraggable = this.slides.length > 1;
    } else {
      this.isDraggable = this.options.draggable;
    }

    this.element.classList.toggle('is-draggable', this.isDraggable);
  };

  proto._uiChangeDrag = function () {
    delete this.isFreeScrolling;
  }; // -------------------------- pointer events -------------------------- //


  proto.handlePointerDown = function (event) {
    if (!this.isDraggable) {
      // proceed for staticClick
      this.bindActivePointerEvents(event);
      return;
    }

    var isTouchStart = event.type === 'touchstart';
    var isTouchPointer = event.pointerType === 'touch';
    var isFocusNode = event.target.matches('input, textarea, select');
    if (!isTouchStart && !isTouchPointer && !isFocusNode) event.preventDefault();
    if (!isFocusNode) this.focus(); // blur

    if (document.activeElement !== this.element) document.activeElement.blur(); // stop if it was moving

    this.dragX = this.x;
    this.viewport.classList.add('is-pointer-down'); // track scrolling

    this.pointerDownScroll = getScrollPosition();
    window.addEventListener('scroll', this);
    this.bindActivePointerEvents(event);
  }; // ----- move ----- //


  proto.hasDragStarted = function (moveVector) {
    return Math.abs(moveVector.x) > this.options.dragThreshold;
  }; // ----- up ----- //


  proto.handlePointerUp = function () {
    delete this.isTouchScrolling;
    this.viewport.classList.remove('is-pointer-down');
  };

  proto.handlePointerDone = function () {
    window.removeEventListener('scroll', this);
    delete this.pointerDownScroll;
  }; // -------------------------- dragging -------------------------- //


  proto.handleDragStart = function () {
    if (!this.isDraggable) return;
    this.dragStartPosition = this.x;
    this.startAnimation();
    window.removeEventListener('scroll', this);
  };

  proto.handleDragMove = function (event, pointer, moveVector) {
    if (!this.isDraggable) return;
    event.preventDefault();
    this.previousDragX = this.dragX; // reverse if right-to-left

    var direction = this.options.rightToLeft ? -1 : 1; // wrap around move. #589

    if (this.isWrapping) moveVector.x %= this.slideableWidth;
    var dragX = this.dragStartPosition + moveVector.x * direction;

    if (!this.isWrapping) {
      // slow drag
      var originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
      dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
      var endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
      dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
    }

    this.dragX = dragX;
    this.dragMoveTime = new Date();
  };

  proto.handleDragEnd = function () {
    if (!this.isDraggable) return;
    var freeScroll = this.options.freeScroll;
    if (freeScroll) this.isFreeScrolling = true; // set selectedIndex based on where flick will end up

    var index = this.dragEndRestingSelect();

    if (freeScroll && !this.isWrapping) {
      // if free-scroll & not wrap around
      // do not free-scroll if going outside of bounding slides
      // so bounding slides can attract slider, and keep it in bounds
      var restingX = this.getRestingPosition();
      this.isFreeScrolling = -restingX > this.slides[0].target && -restingX < this.getLastSlide().target;
    } else if (!freeScroll && index === this.selectedIndex) {
      // boost selection if selected index has not changed
      index += this.dragEndBoostSelect();
    }

    delete this.previousDragX; // apply selection
    // HACK, set flag so dragging stays in correct direction

    this.isDragSelect = this.isWrapping;
    this.select(index);
    delete this.isDragSelect;
  };

  proto.dragEndRestingSelect = function () {
    var restingX = this.getRestingPosition(); // how far away from selected slide

    var distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex)); // get closet resting going up and going down

    var positiveResting = this._getClosestResting(restingX, distance, 1);

    var negativeResting = this._getClosestResting(restingX, distance, -1); // use closer resting for wrap-around


    return positiveResting.distance < negativeResting.distance ? positiveResting.index : negativeResting.index;
  };
  /**
   * given resting X and distance to selected cell
   * get the distance and index of the closest cell
   * @param {Number} restingX - estimated post-flick resting position
   * @param {Number} distance - distance to selected cell
   * @param {Integer} increment - +1 or -1, going up or down
   * @returns {Object} - { distance: {Number}, index: {Integer} }
   */


  proto._getClosestResting = function (restingX, distance, increment) {
    var index = this.selectedIndex;
    var minDistance = Infinity;
    var condition = this.options.contain && !this.isWrapping ? // if containing, keep going if distance is equal to minDistance
    function (dist, minDist) {
      return dist <= minDist;
    } : function (dist, minDist) {
      return dist < minDist;
    };

    while (condition(distance, minDistance)) {
      // measure distance to next cell
      index += increment;
      minDistance = distance;
      distance = this.getSlideDistance(-restingX, index);
      if (distance === null) break;
      distance = Math.abs(distance);
    }

    return {
      distance: minDistance,
      // selected was previous index
      index: index - increment
    };
  };
  /**
   * measure distance between x and a slide target
   * @param {Number} x - horizontal position
   * @param {Integer} index - slide index
   * @returns {Number} - slide distance
   */


  proto.getSlideDistance = function (x, index) {
    var len = this.slides.length; // wrap around if at least 2 slides

    var isWrapAround = this.options.wrapAround && len > 1;
    var slideIndex = isWrapAround ? utils.modulo(index, len) : index;
    var slide = this.slides[slideIndex];
    if (!slide) return null; // add distance for wrap-around slides

    var wrap = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
    return x - (slide.target + wrap);
  };

  proto.dragEndBoostSelect = function () {
    // do not boost if no previousDragX or dragMoveTime
    if (this.previousDragX === undefined || !this.dragMoveTime || // or if drag was held for 100 ms
    new Date() - this.dragMoveTime > 100) {
      return 0;
    }

    var distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
    var delta = this.previousDragX - this.dragX;

    if (distance > 0 && delta > 0) {
      // boost to next if moving towards the right, and positive velocity
      return 1;
    } else if (distance < 0 && delta < 0) {
      // boost to previous if moving towards the left, and negative velocity
      return -1;
    }

    return 0;
  }; // ----- scroll ----- //


  proto.onscroll = function () {
    var scroll = getScrollPosition();
    var scrollMoveX = this.pointerDownScroll.x - scroll.x;
    var scrollMoveY = this.pointerDownScroll.y - scroll.y; // cancel click/tap if scroll is too much

    if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) {
      this.pointerDone();
    }
  }; // ----- utils ----- //


  function getScrollPosition() {
    return {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  } // -----  ----- //


  return Flickity;
});

/***/ }),

/***/ "./node_modules/flickity/js/imagesloaded.js":
/*!**************************************************!*\
  !*** ./node_modules/flickity/js/imagesloaded.js ***!
  \**************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

// imagesloaded
(function (window, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(__webpack_require__(/*! ./core */ "./node_modules/flickity/js/core.js"), __webpack_require__(/*! imagesloaded */ "./node_modules/imagesloaded/imagesloaded.js"));
  } else {
    // browser global
    factory(window.Flickity, window.imagesLoaded);
  }
})(typeof window != 'undefined' ? window : this, function factory(Flickity, imagesLoaded) {
  Flickity.create.imagesLoaded = function () {
    this.on('activate', this.imagesLoaded);
  };

  Flickity.prototype.imagesLoaded = function () {
    var _this = this;

    if (!this.options.imagesLoaded) return;

    var onImagesLoadedProgress = function onImagesLoadedProgress(instance, image) {
      var cell = _this.getParentCell(image.img);

      _this.cellSizeChange(cell && cell.element);

      if (!_this.options.freeScroll) _this.positionSliderAtSelected();
    };

    imagesLoaded(this.slider).on('progress', onImagesLoadedProgress);
  };

  return Flickity;
});

/***/ }),

/***/ "./node_modules/flickity/js/index.js":
/*!*******************************************!*\
  !*** ./node_modules/flickity/js/index.js ***!
  \*******************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/*!
 * Flickity v3.0.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2022 Metafizzy
 */
if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
  var Flickity = __webpack_require__(/*! ./core */ "./node_modules/flickity/js/core.js");

  __webpack_require__(/*! ./drag */ "./node_modules/flickity/js/drag.js");

  __webpack_require__(/*! ./prev-next-button */ "./node_modules/flickity/js/prev-next-button.js");

  __webpack_require__(/*! ./page-dots */ "./node_modules/flickity/js/page-dots.js");

  __webpack_require__(/*! ./player */ "./node_modules/flickity/js/player.js");

  __webpack_require__(/*! ./add-remove-cell */ "./node_modules/flickity/js/add-remove-cell.js");

  __webpack_require__(/*! ./lazyload */ "./node_modules/flickity/js/lazyload.js");

  __webpack_require__(/*! ./imagesloaded */ "./node_modules/flickity/js/imagesloaded.js");

  module.exports = Flickity;
}

/***/ }),

/***/ "./node_modules/flickity/js/lazyload.js":
/*!**********************************************!*\
  !*** ./node_modules/flickity/js/lazyload.js ***!
  \**********************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

// lazyload
(function (window, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(__webpack_require__(/*! ./core */ "./node_modules/flickity/js/core.js"), __webpack_require__(/*! fizzy-ui-utils */ "./node_modules/fizzy-ui-utils/utils.js"));
  } else {
    // browser global
    factory(window.Flickity, window.fizzyUIUtils);
  }
})(typeof window != 'undefined' ? window : this, function factory(Flickity, utils) {
  var lazyAttr = 'data-flickity-lazyload';
  var lazySrcAttr = "".concat(lazyAttr, "-src");
  var lazySrcsetAttr = "".concat(lazyAttr, "-srcset");
  var imgSelector = "img[".concat(lazyAttr, "], img[").concat(lazySrcAttr, "], ") + "img[".concat(lazySrcsetAttr, "], source[").concat(lazySrcsetAttr, "]");

  Flickity.create.lazyLoad = function () {
    this.on('select', this.lazyLoad);
    this.handleLazyLoadComplete = this.onLazyLoadComplete.bind(this);
  };

  var proto = Flickity.prototype;

  proto.lazyLoad = function () {
    var _this = this;

    var lazyLoad = this.options.lazyLoad;
    if (!lazyLoad) return; // get adjacent cells, use lazyLoad option for adjacent count

    var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0; // lazy load images

    this.getAdjacentCellElements(adjCount).map(getCellLazyImages).flat().forEach(function (img) {
      return new LazyLoader(img, _this.handleLazyLoadComplete);
    });
  };

  function getCellLazyImages(cellElem) {
    // check if cell element is lazy image
    if (cellElem.matches('img')) {
      var cellAttr = cellElem.getAttribute(lazyAttr);
      var cellSrcAttr = cellElem.getAttribute(lazySrcAttr);
      var cellSrcsetAttr = cellElem.getAttribute(lazySrcsetAttr);

      if (cellAttr || cellSrcAttr || cellSrcsetAttr) {
        return cellElem;
      }
    } // select lazy images in cell


    return _toConsumableArray(cellElem.querySelectorAll(imgSelector));
  }

  proto.onLazyLoadComplete = function (img, event) {
    var cell = this.getParentCell(img);
    var cellElem = cell && cell.element;
    this.cellSizeChange(cellElem);
    this.dispatchEvent('lazyLoad', event, cellElem);
  }; // -------------------------- LazyLoader -------------------------- //

  /**
   * class to handle loading images
   * @param {Image} img - Image element
   * @param {Function} onComplete - callback function
   */


  function LazyLoader(img, onComplete) {
    this.img = img;
    this.onComplete = onComplete;
    this.load();
  }

  LazyLoader.prototype.handleEvent = utils.handleEvent;

  LazyLoader.prototype.load = function () {
    this.img.addEventListener('load', this);
    this.img.addEventListener('error', this); // get src & srcset

    var src = this.img.getAttribute(lazyAttr) || this.img.getAttribute(lazySrcAttr);
    var srcset = this.img.getAttribute(lazySrcsetAttr); // set src & serset

    this.img.src = src;
    if (srcset) this.img.setAttribute('srcset', srcset); // remove attr

    this.img.removeAttribute(lazyAttr);
    this.img.removeAttribute(lazySrcAttr);
    this.img.removeAttribute(lazySrcsetAttr);
  };

  LazyLoader.prototype.onload = function (event) {
    this.complete(event, 'flickity-lazyloaded');
  };

  LazyLoader.prototype.onerror = function (event) {
    this.complete(event, 'flickity-lazyerror');
  };

  LazyLoader.prototype.complete = function (event, className) {
    // unbind events
    this.img.removeEventListener('load', this);
    this.img.removeEventListener('error', this);
    var mediaElem = this.img.parentNode.matches('picture') ? this.img.parentNode : this.img;
    mediaElem.classList.add(className);
    this.onComplete(this.img, event);
  }; // -----  ----- //


  Flickity.LazyLoader = LazyLoader;
  return Flickity;
});

/***/ }),

/***/ "./node_modules/flickity/js/page-dots.js":
/*!***********************************************!*\
  !*** ./node_modules/flickity/js/page-dots.js ***!
  \***********************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

// page dots
(function (window, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(__webpack_require__(/*! ./core */ "./node_modules/flickity/js/core.js"), __webpack_require__(/*! fizzy-ui-utils */ "./node_modules/fizzy-ui-utils/utils.js"));
  } else {
    // browser global
    factory(window.Flickity, window.fizzyUIUtils);
  }
})(typeof window != 'undefined' ? window : this, function factory(Flickity, utils) {
  // -------------------------- PageDots -------------------------- //
  function PageDots() {
    // create holder element
    this.holder = document.createElement('div');
    this.holder.className = 'flickity-page-dots'; // create dots, array of elements

    this.dots = [];
  }

  PageDots.prototype.setDots = function (slidesLength) {
    // get difference between number of slides and number of dots
    var delta = slidesLength - this.dots.length;

    if (delta > 0) {
      this.addDots(delta);
    } else if (delta < 0) {
      this.removeDots(-delta);
    }
  };

  PageDots.prototype.addDots = function (count) {
    var _this = this,
        _this$holder;

    var newDots = new Array(count).fill().map(function (item, i) {
      var dot = document.createElement('button');
      dot.setAttribute('type', 'button');
      var num = i + 1 + _this.dots.length;
      dot.className = 'flickity-page-dot';
      dot.textContent = "View slide ".concat(num);
      return dot;
    });

    (_this$holder = this.holder).append.apply(_this$holder, _toConsumableArray(newDots));

    this.dots = this.dots.concat(newDots);
  };

  PageDots.prototype.removeDots = function (count) {
    // remove from this.dots collection
    var removeDots = this.dots.splice(this.dots.length - count, count); // remove from DOM

    removeDots.forEach(function (dot) {
      return dot.remove();
    });
  };

  PageDots.prototype.updateSelected = function (index) {
    // remove selected class on previous
    if (this.selectedDot) {
      this.selectedDot.classList.remove('is-selected');
      this.selectedDot.removeAttribute('aria-current');
    } // don't proceed if no dots


    if (!this.dots.length) return;
    this.selectedDot = this.dots[index];
    this.selectedDot.classList.add('is-selected');
    this.selectedDot.setAttribute('aria-current', 'step');
  };

  Flickity.PageDots = PageDots; // -------------------------- Flickity -------------------------- //

  Object.assign(Flickity.defaults, {
    pageDots: true
  });

  Flickity.create.pageDots = function () {
    if (!this.options.pageDots) return;
    this.pageDots = new PageDots();
    this.handlePageDotsClick = this.onPageDotsClick.bind(this); // events

    this.on('activate', this.activatePageDots);
    this.on('select', this.updateSelectedPageDots);
    this.on('cellChange', this.updatePageDots);
    this.on('resize', this.updatePageDots);
    this.on('deactivate', this.deactivatePageDots);
  };

  var proto = Flickity.prototype;

  proto.activatePageDots = function () {
    var _this$focusableElems;

    this.pageDots.setDots(this.slides.length);

    (_this$focusableElems = this.focusableElems).push.apply(_this$focusableElems, _toConsumableArray(this.pageDots.dots));

    this.pageDots.holder.addEventListener('click', this.handlePageDotsClick);
    this.element.append(this.pageDots.holder);
  };

  proto.onPageDotsClick = function (event) {
    var index = this.pageDots.dots.indexOf(event.target);
    if (index === -1) return; // only dot clicks

    this.uiChange();
    this.select(index);
  };

  proto.updateSelectedPageDots = function () {
    this.pageDots.updateSelected(this.selectedIndex);
  };

  proto.updatePageDots = function () {
    var _this2 = this,
        _this$focusableElems2;

    this.pageDots.dots.forEach(function (dot) {
      utils.removeFrom(_this2.focusableElems, dot);
    });
    this.pageDots.setDots(this.slides.length);

    (_this$focusableElems2 = this.focusableElems).push.apply(_this$focusableElems2, _toConsumableArray(this.pageDots.dots));
  };

  proto.deactivatePageDots = function () {
    this.pageDots.holder.remove();
    this.pageDots.holder.removeEventListener('click', this.handlePageDotsClick);
  }; // -----  ----- //


  Flickity.PageDots = PageDots;
  return Flickity;
});

/***/ }),

/***/ "./node_modules/flickity/js/player.js":
/*!********************************************!*\
  !*** ./node_modules/flickity/js/player.js ***!
  \********************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

// player & autoPlay
(function (window, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(__webpack_require__(/*! ./core */ "./node_modules/flickity/js/core.js"));
  } else {
    // browser global
    factory(window.Flickity);
  }
})(typeof window != 'undefined' ? window : this, function factory(Flickity) {
  // -------------------------- Player -------------------------- //
  function Player(autoPlay, onTick) {
    this.autoPlay = autoPlay;
    this.onTick = onTick;
    this.state = 'stopped'; // visibility change event handler

    this.onVisibilityChange = this.visibilityChange.bind(this);
    this.onVisibilityPlay = this.visibilityPlay.bind(this);
  } // start play


  Player.prototype.play = function () {
    if (this.state === 'playing') return; // do not play if page is hidden, start playing when page is visible

    var isPageHidden = document.hidden;

    if (isPageHidden) {
      document.addEventListener('visibilitychange', this.onVisibilityPlay);
      return;
    }

    this.state = 'playing'; // listen to visibility change

    document.addEventListener('visibilitychange', this.onVisibilityChange); // start ticking

    this.tick();
  };

  Player.prototype.tick = function () {
    var _this = this;

    // do not tick if not playing
    if (this.state !== 'playing') return; // default to 3 seconds

    var time = typeof this.autoPlay == 'number' ? this.autoPlay : 3000; // HACK: reset ticks if stopped and started within interval

    this.clear();
    this.timeout = setTimeout(function () {
      _this.onTick();

      _this.tick();
    }, time);
  };

  Player.prototype.stop = function () {
    this.state = 'stopped';
    this.clear(); // remove visibility change event

    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  };

  Player.prototype.clear = function () {
    clearTimeout(this.timeout);
  };

  Player.prototype.pause = function () {
    if (this.state === 'playing') {
      this.state = 'paused';
      this.clear();
    }
  };

  Player.prototype.unpause = function () {
    // re-start play if paused
    if (this.state === 'paused') this.play();
  }; // pause if page visibility is hidden, unpause if visible


  Player.prototype.visibilityChange = function () {
    var isPageHidden = document.hidden;
    this[isPageHidden ? 'pause' : 'unpause']();
  };

  Player.prototype.visibilityPlay = function () {
    this.play();
    document.removeEventListener('visibilitychange', this.onVisibilityPlay);
  }; // -------------------------- Flickity -------------------------- //


  Object.assign(Flickity.defaults, {
    pauseAutoPlayOnHover: true
  });

  Flickity.create.player = function () {
    var _this2 = this;

    this.player = new Player(this.options.autoPlay, function () {
      _this2.next(true);
    });
    this.on('activate', this.activatePlayer);
    this.on('uiChange', this.stopPlayer);
    this.on('pointerDown', this.stopPlayer);
    this.on('deactivate', this.deactivatePlayer);
  };

  var proto = Flickity.prototype;

  proto.activatePlayer = function () {
    if (!this.options.autoPlay) return;
    this.player.play();
    this.element.addEventListener('mouseenter', this);
  }; // Player API, don't hate the ... thanks I know where the door is


  proto.playPlayer = function () {
    this.player.play();
  };

  proto.stopPlayer = function () {
    this.player.stop();
  };

  proto.pausePlayer = function () {
    this.player.pause();
  };

  proto.unpausePlayer = function () {
    this.player.unpause();
  };

  proto.deactivatePlayer = function () {
    this.player.stop();
    this.element.removeEventListener('mouseenter', this);
  }; // ----- mouseenter/leave ----- //
  // pause auto-play on hover


  proto.onmouseenter = function () {
    if (!this.options.pauseAutoPlayOnHover) return;
    this.player.pause();
    this.element.addEventListener('mouseleave', this);
  }; // resume auto-play on hover off


  proto.onmouseleave = function () {
    this.player.unpause();
    this.element.removeEventListener('mouseleave', this);
  }; // -----  ----- //


  Flickity.Player = Player;
  return Flickity;
});

/***/ }),

/***/ "./node_modules/flickity/js/prev-next-button.js":
/*!******************************************************!*\
  !*** ./node_modules/flickity/js/prev-next-button.js ***!
  \******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

// prev/next buttons
(function (window, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(__webpack_require__(/*! ./core */ "./node_modules/flickity/js/core.js"));
  } else {
    // browser global
    factory(window.Flickity);
  }
})(typeof window != 'undefined' ? window : this, function factory(Flickity) {
  var svgURI = 'http://www.w3.org/2000/svg'; // -------------------------- PrevNextButton -------------------------- //

  function PrevNextButton(increment, direction, arrowShape) {
    this.increment = increment;
    this.direction = direction;
    this.isPrevious = increment === 'previous';
    this.isLeft = direction === 'left';

    this._create(arrowShape);
  }

  PrevNextButton.prototype._create = function (arrowShape) {
    // properties
    var element = this.element = document.createElement('button');
    element.className = "flickity-button flickity-prev-next-button ".concat(this.increment);
    var label = this.isPrevious ? 'Previous' : 'Next'; // prevent button from submitting form https://stackoverflow.com/a/10836076/182183

    element.setAttribute('type', 'button');
    element.setAttribute('aria-label', label); // init as disabled

    this.disable(); // create arrow

    var svg = this.createSVG(label, arrowShape);
    element.append(svg);
  };

  PrevNextButton.prototype.createSVG = function (label, arrowShape) {
    var svg = document.createElementNS(svgURI, 'svg');
    svg.setAttribute('class', 'flickity-button-icon');
    svg.setAttribute('viewBox', '0 0 100 100'); // add title #1189

    var title = document.createElementNS(svgURI, 'title');
    title.append(label); // add path

    var path = document.createElementNS(svgURI, 'path');
    var pathMovements = getArrowMovements(arrowShape);
    path.setAttribute('d', pathMovements);
    path.setAttribute('class', 'arrow'); // rotate arrow

    if (!this.isLeft) {
      path.setAttribute('transform', 'translate(100, 100) rotate(180)');
    }

    svg.append(title, path);
    return svg;
  }; // get SVG path movmement


  function getArrowMovements(shape) {
    // use shape as movement if string
    if (typeof shape == 'string') return shape;
    var x0 = shape.x0,
        x1 = shape.x1,
        x2 = shape.x2,
        x3 = shape.x3,
        y1 = shape.y1,
        y2 = shape.y2; // create movement string

    return "M ".concat(x0, ", 50\n    L ").concat(x1, ", ").concat(y1 + 50, "\n    L ").concat(x2, ", ").concat(y2 + 50, "\n    L ").concat(x3, ", 50\n    L ").concat(x2, ", ").concat(50 - y2, "\n    L ").concat(x1, ", ").concat(50 - y1, "\n    Z");
  } // -----  ----- //


  PrevNextButton.prototype.enable = function () {
    this.element.removeAttribute('disabled');
  };

  PrevNextButton.prototype.disable = function () {
    this.element.setAttribute('disabled', true);
  }; // -------------------------- Flickity prototype -------------------------- //


  Object.assign(Flickity.defaults, {
    prevNextButtons: true,
    arrowShape: {
      x0: 10,
      x1: 60,
      y1: 50,
      x2: 70,
      y2: 40,
      x3: 30
    }
  });

  Flickity.create.prevNextButtons = function () {
    var _this = this;

    if (!this.options.prevNextButtons) return;
    var _this$options = this.options,
        rightToLeft = _this$options.rightToLeft,
        arrowShape = _this$options.arrowShape;
    var prevDirection = rightToLeft ? 'right' : 'left';
    var nextDirection = rightToLeft ? 'left' : 'right';
    this.prevButton = new PrevNextButton('previous', prevDirection, arrowShape);
    this.nextButton = new PrevNextButton('next', nextDirection, arrowShape);
    this.focusableElems.push(this.prevButton.element);
    this.focusableElems.push(this.nextButton.element);

    this.handlePrevButtonClick = function () {
      _this.uiChange();

      _this.previous();
    };

    this.handleNextButtonClick = function () {
      _this.uiChange();

      _this.next();
    };

    this.on('activate', this.activatePrevNextButtons);
    this.on('select', this.updatePrevNextButtons);
  };

  var proto = Flickity.prototype;

  proto.updatePrevNextButtons = function () {
    var lastIndex = this.slides.length ? this.slides.length - 1 : 0;
    this.updatePrevNextButton(this.prevButton, 0);
    this.updatePrevNextButton(this.nextButton, lastIndex);
  };

  proto.updatePrevNextButton = function (button, disabledIndex) {
    // enable is wrapAround and at least 2 slides
    if (this.isWrapping && this.slides.length > 1) {
      button.enable();
      return;
    }

    var isEnabled = this.selectedIndex !== disabledIndex;
    button[isEnabled ? 'enable' : 'disable'](); // if disabling button that is focused,
    // shift focus to element to maintain keyboard accessibility

    var isDisabledFocused = !isEnabled && document.activeElement === button.element;
    if (isDisabledFocused) this.focus();
  };

  proto.activatePrevNextButtons = function () {
    this.prevButton.element.addEventListener('click', this.handlePrevButtonClick);
    this.nextButton.element.addEventListener('click', this.handleNextButtonClick);
    this.element.append(this.prevButton.element, this.nextButton.element);
    this.on('deactivate', this.deactivatePrevNextButtons);
  };

  proto.deactivatePrevNextButtons = function () {
    this.prevButton.element.remove();
    this.nextButton.element.remove();
    this.prevButton.element.removeEventListener('click', this.handlePrevButtonClick);
    this.nextButton.element.removeEventListener('click', this.handleNextButtonClick);
    this.off('deactivate', this.deactivatePrevNextButtons);
  }; // --------------------------  -------------------------- //


  Flickity.PrevNextButton = PrevNextButton;
  return Flickity;
});

/***/ }),

/***/ "./node_modules/flickity/js/slide.js":
/*!*******************************************!*\
  !*** ./node_modules/flickity/js/slide.js ***!
  \*******************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

// slide
(function (window, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.Slide = factory();
  }
})(typeof window != 'undefined' ? window : this, function factory() {
  function Slide(beginMargin, endMargin, cellAlign) {
    this.beginMargin = beginMargin;
    this.endMargin = endMargin;
    this.cellAlign = cellAlign;
    this.cells = [];
    this.outerWidth = 0;
    this.height = 0;
  }

  var proto = Slide.prototype;

  proto.addCell = function (cell) {
    this.cells.push(cell);
    this.outerWidth += cell.size.outerWidth;
    this.height = Math.max(cell.size.outerHeight, this.height); // first cell stuff

    if (this.cells.length === 1) {
      this.x = cell.x; // x comes from first cell

      this.firstMargin = cell.size[this.beginMargin];
    }
  };

  proto.updateTarget = function () {
    var lastCell = this.getLastCell();
    var lastMargin = lastCell ? lastCell.size[this.endMargin] : 0;
    var slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
    this.target = this.x + this.firstMargin + slideWidth * this.cellAlign;
  };

  proto.getLastCell = function () {
    return this.cells[this.cells.length - 1];
  };

  proto.select = function () {
    this.cells.forEach(function (cell) {
      return cell.select();
    });
  };

  proto.unselect = function () {
    this.cells.forEach(function (cell) {
      return cell.unselect();
    });
  };

  proto.getCellElements = function () {
    return this.cells.map(function (cell) {
      return cell.element;
    });
  };

  return Slide;
});

/***/ }),

/***/ "./node_modules/get-size/get-size.js":
/*!*******************************************!*\
  !*** ./node_modules/get-size/get-size.js ***!
  \*******************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/*!
 * Infinite Scroll v2.0.4
 * measure size of elements
 * MIT license
 */
(function (window, factory) {
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.getSize = factory();
  }
})(window, function factory() {
  // -------------------------- helpers -------------------------- //
  // get a number from a string, not a percentage
  function getStyleSize(value) {
    var num = parseFloat(value); // not a percent like '100%', and a number

    var isValid = value.indexOf('%') == -1 && !isNaN(num);
    return isValid && num;
  } // -------------------------- measurements -------------------------- //


  var measurements = ['paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth', 'borderBottomWidth'];
  var measurementsLength = measurements.length;

  function getZeroSize() {
    var size = {
      width: 0,
      height: 0,
      innerWidth: 0,
      innerHeight: 0,
      outerWidth: 0,
      outerHeight: 0
    };
    measurements.forEach(function (measurement) {
      size[measurement] = 0;
    });
    return size;
  } // -------------------------- getSize -------------------------- //


  function getSize(elem) {
    // use querySeletor if elem is string
    if (typeof elem == 'string') elem = document.querySelector(elem); // do not proceed on non-objects

    var isElement = elem && _typeof(elem) == 'object' && elem.nodeType;
    if (!isElement) return;
    var style = getComputedStyle(elem); // if hidden, everything is 0

    if (style.display == 'none') return getZeroSize();
    var size = {};
    size.width = elem.offsetWidth;
    size.height = elem.offsetHeight;
    var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box'; // get all measurements

    measurements.forEach(function (measurement) {
      var value = style[measurement];
      var num = parseFloat(value); // any 'auto', 'medium' value will be 0

      size[measurement] = !isNaN(num) ? num : 0;
    });
    var paddingWidth = size.paddingLeft + size.paddingRight;
    var paddingHeight = size.paddingTop + size.paddingBottom;
    var marginWidth = size.marginLeft + size.marginRight;
    var marginHeight = size.marginTop + size.marginBottom;
    var borderWidth = size.borderLeftWidth + size.borderRightWidth;
    var borderHeight = size.borderTopWidth + size.borderBottomWidth; // overwrite width and height if we can get it from style

    var styleWidth = getStyleSize(style.width);

    if (styleWidth !== false) {
      size.width = styleWidth + ( // add padding and border unless it's already including it
      isBorderBox ? 0 : paddingWidth + borderWidth);
    }

    var styleHeight = getStyleSize(style.height);

    if (styleHeight !== false) {
      size.height = styleHeight + ( // add padding and border unless it's already including it
      isBorderBox ? 0 : paddingHeight + borderHeight);
    }

    size.innerWidth = size.width - (paddingWidth + borderWidth);
    size.innerHeight = size.height - (paddingHeight + borderHeight);
    size.outerWidth = size.width + marginWidth;
    size.outerHeight = size.height + marginHeight;
    return size;
  }

  return getSize;
});

/***/ }),

/***/ "./node_modules/imagesloaded/imagesloaded.js":
/*!***************************************************!*\
  !*** ./node_modules/imagesloaded/imagesloaded.js ***!
  \***************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/*!
 * imagesLoaded v5.0.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */
(function (window, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, __webpack_require__(/*! ev-emitter */ "./node_modules/ev-emitter/ev-emitter.js"));
  } else {
    // browser global
    window.imagesLoaded = factory(window, window.EvEmitter);
  }
})(typeof window !== 'undefined' ? window : this, function factory(window, EvEmitter) {
  var $ = window.jQuery;
  var console = window.console; // -------------------------- helpers -------------------------- //
  // turn element or nodeList into an array

  function makeArray(obj) {
    // use object if already an array
    if (Array.isArray(obj)) return obj;
    var isArrayLike = _typeof(obj) == 'object' && typeof obj.length == 'number'; // convert nodeList to array

    if (isArrayLike) return _toConsumableArray(obj); // array of single index

    return [obj];
  } // -------------------------- imagesLoaded -------------------------- //

  /**
   * @param {[Array, Element, NodeList, String]} elem
   * @param {[Object, Function]} options - if function, use as callback
   * @param {Function} onAlways - callback function
   * @returns {ImagesLoaded}
   */


  function ImagesLoaded(elem, options, onAlways) {
    // coerce ImagesLoaded() without new, to be new ImagesLoaded()
    if (!(this instanceof ImagesLoaded)) {
      return new ImagesLoaded(elem, options, onAlways);
    } // use elem as selector string


    var queryElem = elem;

    if (typeof elem == 'string') {
      queryElem = document.querySelectorAll(elem);
    } // bail if bad element


    if (!queryElem) {
      console.error("Bad element for imagesLoaded ".concat(queryElem || elem));
      return;
    }

    this.elements = makeArray(queryElem);
    this.options = {}; // shift arguments if no options set

    if (typeof options == 'function') {
      onAlways = options;
    } else {
      Object.assign(this.options, options);
    }

    if (onAlways) this.on('always', onAlways);
    this.getImages(); // add jQuery Deferred object

    if ($) this.jqDeferred = new $.Deferred(); // HACK check async to allow time to bind listeners

    setTimeout(this.check.bind(this));
  }

  ImagesLoaded.prototype = Object.create(EvEmitter.prototype);

  ImagesLoaded.prototype.getImages = function () {
    this.images = []; // filter & find items if we have an item selector

    this.elements.forEach(this.addElementImages, this);
  };

  var elementNodeTypes = [1, 9, 11];
  /**
   * @param {Node} elem
   */

  ImagesLoaded.prototype.addElementImages = function (elem) {
    // filter siblings
    if (elem.nodeName === 'IMG') {
      this.addImage(elem);
    } // get background image on element


    if (this.options.background === true) {
      this.addElementBackgroundImages(elem);
    } // find children
    // no non-element nodes, #143


    var nodeType = elem.nodeType;
    if (!nodeType || !elementNodeTypes.includes(nodeType)) return;
    var childImgs = elem.querySelectorAll('img'); // concat childElems to filterFound array

    var _iterator = _createForOfIteratorHelper(childImgs),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var img = _step.value;
        this.addImage(img);
      } // get child background images

    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (typeof this.options.background == 'string') {
      var children = elem.querySelectorAll(this.options.background);

      var _iterator2 = _createForOfIteratorHelper(children),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var child = _step2.value;
          this.addElementBackgroundImages(child);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  };

  var reURL = /url\((['"])?(.*?)\1\)/gi;

  ImagesLoaded.prototype.addElementBackgroundImages = function (elem) {
    var style = getComputedStyle(elem); // Firefox returns null if in a hidden iframe https://bugzil.la/548397

    if (!style) return; // get url inside url("...")

    var matches = reURL.exec(style.backgroundImage);

    while (matches !== null) {
      var url = matches && matches[2];

      if (url) {
        this.addBackground(url, elem);
      }

      matches = reURL.exec(style.backgroundImage);
    }
  };
  /**
   * @param {Image} img
   */


  ImagesLoaded.prototype.addImage = function (img) {
    var loadingImage = new LoadingImage(img);
    this.images.push(loadingImage);
  };

  ImagesLoaded.prototype.addBackground = function (url, elem) {
    var background = new Background(url, elem);
    this.images.push(background);
  };

  ImagesLoaded.prototype.check = function () {
    var _this = this;

    this.progressedCount = 0;
    this.hasAnyBroken = false; // complete if no images

    if (!this.images.length) {
      this.complete();
      return;
    }
    /* eslint-disable-next-line func-style */


    var onProgress = function onProgress(image, elem, message) {
      // HACK - Chrome triggers event before object properties have changed. #83
      setTimeout(function () {
        _this.progress(image, elem, message);
      });
    };

    this.images.forEach(function (loadingImage) {
      loadingImage.once('progress', onProgress);
      loadingImage.check();
    });
  };

  ImagesLoaded.prototype.progress = function (image, elem, message) {
    this.progressedCount++;
    this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded; // progress event

    this.emitEvent('progress', [this, image, elem]);

    if (this.jqDeferred && this.jqDeferred.notify) {
      this.jqDeferred.notify(this, image);
    } // check if completed


    if (this.progressedCount === this.images.length) {
      this.complete();
    }

    if (this.options.debug && console) {
      console.log("progress: ".concat(message), image, elem);
    }
  };

  ImagesLoaded.prototype.complete = function () {
    var eventName = this.hasAnyBroken ? 'fail' : 'done';
    this.isComplete = true;
    this.emitEvent(eventName, [this]);
    this.emitEvent('always', [this]);

    if (this.jqDeferred) {
      var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
      this.jqDeferred[jqMethod](this);
    }
  }; // --------------------------  -------------------------- //


  function LoadingImage(img) {
    this.img = img;
  }

  LoadingImage.prototype = Object.create(EvEmitter.prototype);

  LoadingImage.prototype.check = function () {
    // If complete is true and browser supports natural sizes,
    // try to check for image status manually.
    var isComplete = this.getIsImageComplete();

    if (isComplete) {
      // report based on naturalWidth
      this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
      return;
    } // If none of the checks above matched, simulate loading on detached element.


    this.proxyImage = new Image(); // add crossOrigin attribute. #204

    if (this.img.crossOrigin) {
      this.proxyImage.crossOrigin = this.img.crossOrigin;
    }

    this.proxyImage.addEventListener('load', this);
    this.proxyImage.addEventListener('error', this); // bind to image as well for Firefox. #191

    this.img.addEventListener('load', this);
    this.img.addEventListener('error', this);
    this.proxyImage.src = this.img.currentSrc || this.img.src;
  };

  LoadingImage.prototype.getIsImageComplete = function () {
    // check for non-zero, non-undefined naturalWidth
    // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
    return this.img.complete && this.img.naturalWidth;
  };

  LoadingImage.prototype.confirm = function (isLoaded, message) {
    this.isLoaded = isLoaded;
    var parentNode = this.img.parentNode; // emit progress with parent <picture> or self <img>

    var elem = parentNode.nodeName === 'PICTURE' ? parentNode : this.img;
    this.emitEvent('progress', [this, elem, message]);
  }; // ----- events ----- //
  // trigger specified handler for event type


  LoadingImage.prototype.handleEvent = function (event) {
    var method = 'on' + event.type;

    if (this[method]) {
      this[method](event);
    }
  };

  LoadingImage.prototype.onload = function () {
    this.confirm(true, 'onload');
    this.unbindEvents();
  };

  LoadingImage.prototype.onerror = function () {
    this.confirm(false, 'onerror');
    this.unbindEvents();
  };

  LoadingImage.prototype.unbindEvents = function () {
    this.proxyImage.removeEventListener('load', this);
    this.proxyImage.removeEventListener('error', this);
    this.img.removeEventListener('load', this);
    this.img.removeEventListener('error', this);
  }; // -------------------------- Background -------------------------- //


  function Background(url, element) {
    this.url = url;
    this.element = element;
    this.img = new Image();
  } // inherit LoadingImage prototype


  Background.prototype = Object.create(LoadingImage.prototype);

  Background.prototype.check = function () {
    this.img.addEventListener('load', this);
    this.img.addEventListener('error', this);
    this.img.src = this.url; // check if image is already complete

    var isComplete = this.getIsImageComplete();

    if (isComplete) {
      this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
      this.unbindEvents();
    }
  };

  Background.prototype.unbindEvents = function () {
    this.img.removeEventListener('load', this);
    this.img.removeEventListener('error', this);
  };

  Background.prototype.confirm = function (isLoaded, message) {
    this.isLoaded = isLoaded;
    this.emitEvent('progress', [this, this.element, message]);
  }; // -------------------------- jQuery -------------------------- //


  ImagesLoaded.makeJQueryPlugin = function (jQuery) {
    jQuery = jQuery || window.jQuery;
    if (!jQuery) return; // set local variable

    $ = jQuery; // $().imagesLoaded()

    $.fn.imagesLoaded = function (options, onAlways) {
      var instance = new ImagesLoaded(this, options, onAlways);
      return instance.jqDeferred.promise($(this));
    };
  }; // try making plugin


  ImagesLoaded.makeJQueryPlugin(); // --------------------------  -------------------------- //

  return ImagesLoaded;
});

/***/ }),

/***/ "./node_modules/unidragger/unidragger.js":
/*!***********************************************!*\
  !*** ./node_modules/unidragger/unidragger.js ***!
  \***********************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/*!
 * Unidragger v3.0.1
 * Draggable base class
 * MIT license
 */
(function (window, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, __webpack_require__(/*! ev-emitter */ "./node_modules/ev-emitter/ev-emitter.js"));
  } else {
    // browser global
    window.Unidragger = factory(window, window.EvEmitter);
  }
})(typeof window != 'undefined' ? window : this, function factory(window, EvEmitter) {
  function Unidragger() {} // inherit EvEmitter


  var proto = Unidragger.prototype = Object.create(EvEmitter.prototype); // ----- bind start ----- //
  // trigger handler methods for events

  proto.handleEvent = function (event) {
    var method = 'on' + event.type;

    if (this[method]) {
      this[method](event);
    }
  };

  var startEvent, activeEvents;

  if ('ontouchstart' in window) {
    // HACK prefer Touch Events as you can preventDefault on touchstart to
    // disable scroll in iOS & mobile Chrome metafizzy/flickity#1177
    startEvent = 'touchstart';
    activeEvents = ['touchmove', 'touchend', 'touchcancel'];
  } else if (window.PointerEvent) {
    // Pointer Events
    startEvent = 'pointerdown';
    activeEvents = ['pointermove', 'pointerup', 'pointercancel'];
  } else {
    // mouse events
    startEvent = 'mousedown';
    activeEvents = ['mousemove', 'mouseup'];
  } // prototype so it can be overwriteable by Flickity


  proto.touchActionValue = 'none';

  proto.bindHandles = function () {
    this._bindHandles('addEventListener', this.touchActionValue);
  };

  proto.unbindHandles = function () {
    this._bindHandles('removeEventListener', '');
  };
  /**
   * Add or remove start event
   * @param {String} bindMethod - addEventListener or removeEventListener
   * @param {String} touchAction - value for touch-action CSS property
   */


  proto._bindHandles = function (bindMethod, touchAction) {
    var _this = this;

    this.handles.forEach(function (handle) {
      handle[bindMethod](startEvent, _this);
      handle[bindMethod]('click', _this); // touch-action: none to override browser touch gestures. metafizzy/flickity#540

      if (window.PointerEvent) handle.style.touchAction = touchAction;
    });
  };

  proto.bindActivePointerEvents = function () {
    var _this2 = this;

    activeEvents.forEach(function (eventName) {
      window.addEventListener(eventName, _this2);
    });
  };

  proto.unbindActivePointerEvents = function () {
    var _this3 = this;

    activeEvents.forEach(function (eventName) {
      window.removeEventListener(eventName, _this3);
    });
  }; // ----- event handler helpers ----- //
  // trigger method with matching pointer


  proto.withPointer = function (methodName, event) {
    if (event.pointerId === this.pointerIdentifier) {
      this[methodName](event, event);
    }
  }; // trigger method with matching touch


  proto.withTouch = function (methodName, event) {
    var touch;

    var _iterator = _createForOfIteratorHelper(event.changedTouches),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var changedTouch = _step.value;

        if (changedTouch.identifier === this.pointerIdentifier) {
          touch = changedTouch;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (touch) this[methodName](event, touch);
  }; // ----- start event ----- //


  proto.onmousedown = function (event) {
    this.pointerDown(event, event);
  };

  proto.ontouchstart = function (event) {
    this.pointerDown(event, event.changedTouches[0]);
  };

  proto.onpointerdown = function (event) {
    this.pointerDown(event, event);
  }; // nodes that have text fields


  var cursorNodes = ['TEXTAREA', 'INPUT', 'SELECT', 'OPTION']; // input types that do not have text fields

  var clickTypes = ['radio', 'checkbox', 'button', 'submit', 'image', 'file'];
  /**
   * any time you set `event, pointer` it refers to:
   * @param {Event} event
   * @param {Event | Touch} pointer
   */

  proto.pointerDown = function (event, pointer) {
    // dismiss multi-touch taps, right clicks, and clicks on text fields
    var isCursorNode = cursorNodes.includes(event.target.nodeName);
    var isClickType = clickTypes.includes(event.target.type);
    var isOkayElement = !isCursorNode || isClickType;
    var isOkay = !this.isPointerDown && !event.button && isOkayElement;
    if (!isOkay) return;
    this.isPointerDown = true; // save pointer identifier to match up touch events

    this.pointerIdentifier = pointer.pointerId !== undefined ? // pointerId for pointer events, touch.indentifier for touch events
    pointer.pointerId : pointer.identifier; // track position for move

    this.pointerDownPointer = {
      pageX: pointer.pageX,
      pageY: pointer.pageY
    };
    this.bindActivePointerEvents();
    this.emitEvent('pointerDown', [event, pointer]);
  }; // ----- move ----- //


  proto.onmousemove = function (event) {
    this.pointerMove(event, event);
  };

  proto.onpointermove = function (event) {
    this.withPointer('pointerMove', event);
  };

  proto.ontouchmove = function (event) {
    this.withTouch('pointerMove', event);
  };

  proto.pointerMove = function (event, pointer) {
    var moveVector = {
      x: pointer.pageX - this.pointerDownPointer.pageX,
      y: pointer.pageY - this.pointerDownPointer.pageY
    };
    this.emitEvent('pointerMove', [event, pointer, moveVector]); // start drag if pointer has moved far enough to start drag

    var isDragStarting = !this.isDragging && this.hasDragStarted(moveVector);
    if (isDragStarting) this.dragStart(event, pointer);
    if (this.isDragging) this.dragMove(event, pointer, moveVector);
  }; // condition if pointer has moved far enough to start drag


  proto.hasDragStarted = function (moveVector) {
    return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
  }; // ----- drag ----- //


  proto.dragStart = function (event, pointer) {
    this.isDragging = true;
    this.isPreventingClicks = true; // set flag to prevent clicks

    this.emitEvent('dragStart', [event, pointer]);
  };

  proto.dragMove = function (event, pointer, moveVector) {
    this.emitEvent('dragMove', [event, pointer, moveVector]);
  }; // ----- end ----- //


  proto.onmouseup = function (event) {
    this.pointerUp(event, event);
  };

  proto.onpointerup = function (event) {
    this.withPointer('pointerUp', event);
  };

  proto.ontouchend = function (event) {
    this.withTouch('pointerUp', event);
  };

  proto.pointerUp = function (event, pointer) {
    this.pointerDone();
    this.emitEvent('pointerUp', [event, pointer]);

    if (this.isDragging) {
      this.dragEnd(event, pointer);
    } else {
      // pointer didn't move enough for drag to start
      this.staticClick(event, pointer);
    }
  };

  proto.dragEnd = function (event, pointer) {
    var _this4 = this;

    this.isDragging = false; // reset flag
    // re-enable clicking async

    setTimeout(function () {
      return delete _this4.isPreventingClicks;
    });
    this.emitEvent('dragEnd', [event, pointer]);
  }; // triggered on pointer up & pointer cancel


  proto.pointerDone = function () {
    this.isPointerDown = false;
    delete this.pointerIdentifier;
    this.unbindActivePointerEvents();
    this.emitEvent('pointerDone');
  }; // ----- cancel ----- //


  proto.onpointercancel = function (event) {
    this.withPointer('pointerCancel', event);
  };

  proto.ontouchcancel = function (event) {
    this.withTouch('pointerCancel', event);
  };

  proto.pointerCancel = function (event, pointer) {
    this.pointerDone();
    this.emitEvent('pointerCancel', [event, pointer]);
  }; // ----- click ----- //
  // handle all clicks and prevent clicks when dragging


  proto.onclick = function (event) {
    if (this.isPreventingClicks) event.preventDefault();
  }; // triggered after pointer down & up with no/tiny movement


  proto.staticClick = function (event, pointer) {
    var _this5 = this;

    // ignore emulated mouse up clicks
    var isMouseup = event.type === 'mouseup';
    if (isMouseup && this.isIgnoringMouseUp) return;
    this.emitEvent('staticClick', [event, pointer]); // set flag for emulated clicks 300ms after touchend

    if (isMouseup) {
      this.isIgnoringMouseUp = true; // reset flag after 400ms

      setTimeout(function () {
        delete _this5.isIgnoringMouseUp;
      }, 400);
    }
  }; // -----  ----- //


  return Unidragger;
});

/***/ }),

/***/ "./src/js/modules/drawer-listener.js":
/*!*******************************************!*\
  !*** ./src/js/modules/drawer-listener.js ***!
  \*******************************************/
/***/ (() => {

document.addEventListener("mobile-nav:open", drawerActive);
document.addEventListener("mobile-nav:close", drawerClose);

function drawerActive() {
  document.body.classList.add('drawer-open');
}

function drawerClose() {
  document.body.classList.remove('drawer-open');
}

/***/ }),

/***/ "./src/js/modules/ed-b2b-compare-price.js":
/*!************************************************!*\
  !*** ./src/js/modules/ed-b2b-compare-price.js ***!
  \************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdB2bComparePrice = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdB2bComparePrice, _HTMLElement);

  var _super = _createSuper(EdB2bComparePrice);

  function EdB2bComparePrice() {
    _classCallCheck(this, EdB2bComparePrice);

    return _super.apply(this, arguments);
  }

  _createClass(EdB2bComparePrice, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.productData = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;

      document.addEventListener('variant:changed', function (event) {
        _this._onVariantChanged(event);
      });
    }
  }, {
    key: "_onVariantChanged",
    value: function _onVariantChanged(event) {
      var variantId = event.detail.variant.id;
      var variantData = this.productData.find(function (variant) {
        return variant.id === variantId;
      });

      if (variantData) {
        this._updatePriceDisplay(variantData.b2b_variant_price);

        this._updateSavingsDisplay(variantData, event.detail.variant.price); // DISABLED BY JO-ELBDEV

      } else {
        console.error('Variant data not found for id:', variantId);
      }
    }
  }, {
    key: "_updatePriceDisplay",
    value: function _updatePriceDisplay(newPrice) {
      var priceElement = this.querySelector('.ed-b2b-price--compare');

      if (priceElement) {
        var priceInEuros = newPrice / 100;
        var isWholeNumber = priceInEuros % 1 === 0;
        priceElement.textContent = isWholeNumber ? "".concat(priceInEuros, " \u20AC") : "".concat(priceInEuros.toFixed(2).replace('.', ','), " \u20AC");
      }
    }
  }, {
    key: "_updateSavingsDisplay",
    value: function _updateSavingsDisplay(variantData, variantPrice) {
      var savingsElement = document.querySelector('.ed-label--highlight');
      var originalPrice = variantData.b2b_variant_price;
      var savings = originalPrice - variantPrice;

      var savingsFormatted = this._formatMoneyWithoutTrailingZeros(savings);

      if (savingsElement) {
        savingsElement.innerHTML = "(Du sparst ".concat(savingsFormatted, ")");
      }
    }
  }, {
    key: "_formatMoneyWithoutTrailingZeros",
    value: function _formatMoneyWithoutTrailingZeros(amount) {
      var priceInEuros = amount / 100;
      var isWholeNumber = priceInEuros % 1 === 0;
      return isWholeNumber ? "".concat(priceInEuros, " \u20AC") : "".concat(priceInEuros.toFixed(2).replace('.', ','), " \u20AC");
    }
  }]);

  return EdB2bComparePrice;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-b2b-compare-price', EdB2bComparePrice);

/***/ }),

/***/ "./src/js/modules/ed-cart-upsell-items.js":
/*!************************************************!*\
  !*** ./src/js/modules/ed-cart-upsell-items.js ***!
  \************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdCartUpsellItems = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdCartUpsellItems, _HTMLElement);

  var _super = _createSuper(EdCartUpsellItems);

  function EdCartUpsellItems() {
    _classCallCheck(this, EdCartUpsellItems);

    return _super.apply(this, arguments);
  }

  _createClass(EdCartUpsellItems, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.atcButtons = this.querySelectorAll('.upsell-atc-btn');
      this.buttons = this.querySelectorAll('.dazu-passt-wrapper button');
      this.contentDivs = this.querySelectorAll('.dazu-passt-content');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;

      this.atcButtons.forEach(function (button) {
        button.addEventListener('click', _this._addUpsellItemToCart.bind(_this));
      });
      this.buttons.forEach(function (button) {
        button.addEventListener('mouseenter', _this._handleMouseEnter.bind(_this));
        button.addEventListener('mouseleave', _this._handleMouseLeave.bind(_this));
      });
      this.contentDivs.forEach(function (div) {
        div.addEventListener('mouseenter', _this._handleMouseEnter.bind(_this));
        div.addEventListener('mouseleave', _this._handleMouseLeave.bind(_this));
      });
    }
  }, {
    key: "_handleMouseEnter",
    value: function _handleMouseEnter(event) {
      var wrapper = event.currentTarget.closest('.upsell-item-wrapper');
      if (wrapper) wrapper.classList.add('hovered');
    }
  }, {
    key: "_handleMouseLeave",
    value: function _handleMouseLeave(event) {
      var wrapper = event.currentTarget.closest('.upsell-item-wrapper');
      if (wrapper) wrapper.classList.remove('hovered');
    }
  }, {
    key: "_addUpsellItemToCart",
    value: function _addUpsellItemToCart(event) {
      event.preventDefault(); // Ignoring non-mouse triggered event

      if (event.detail === 0) {
        return;
      }

      var button = event.currentTarget;
      var wrapper = event.currentTarget.closest('.upsell-item-wrapper');
      var variantId = wrapper.getAttribute('data-variant-id');
      button.setAttribute('ed-loading', 'true');

      if (!variantId) {
        console.error("Unable to find variant ID for the product.");
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.status === 422) {
          console.error(data.message);
        } else {
          location.reload();
        }

        button.removeAttribute('ed-loading');
      })["catch"](function (error) {
        console.error("Error adding item to cart:", error);
      });
    }
  }]);

  return EdCartUpsellItems;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-cart-upsell-items', EdCartUpsellItems);

/***/ }),

/***/ "./src/js/modules/ed-drawer-free-gift.js":
/*!***********************************************!*\
  !*** ./src/js/modules/ed-drawer-free-gift.js ***!
  \***********************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var CartDrawerAutoFreeGift = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CartDrawerAutoFreeGift, _HTMLElement);

  var _super = _createSuper(CartDrawerAutoFreeGift);

  function CartDrawerAutoFreeGift() {
    _classCallCheck(this, CartDrawerAutoFreeGift);

    return _super.apply(this, arguments);
  }

  _createClass(CartDrawerAutoFreeGift, [{
    key: "cartTotal",
    get: function get() {
      return this.getAttribute('cart-total');
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.freeGiftId = this.getAttribute('fg-item-id');
      this.threshold = this.getAttribute('threshold');

      this._attachSelectors();

      this._attachListeners();

      this.validateFreeGift();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      document.addEventListener('cart:change', this.validateFreeGift.bind(this));
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {}
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {}
  }, {
    key: "validateFreeGift",
    value: function validateFreeGift(e) {
      var cartTotal = parseInt(this.cartTotal);
      var isFreeGiftInCart = this.getAttribute('free-gift-already-in-cart');
      var threshold = parseInt(this.threshold); // Zeit aus sessionStorage holen

      var lastGiftTime = sessionStorage.getItem('freeGiftTimestamp');
      var now = Date.now();

      if (lastGiftTime && now - parseInt(lastGiftTime) < 10 * 60 * 1000) {
        //console.log('Free gift wurde bereits in den letzten 10 Minuten hinzugefügt.');
        return; // Nicht nochmal ausführen
      }

      if (!isFreeGiftInCart && cartTotal >= threshold) {
        this.addFreeGiftToCart(this.freeGiftId);
      }
    }
  }, {
    key: "addFreeGiftToCart",
    value: function addFreeGiftToCart(id) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: id,
          quantity: 1
        })
      }).then(function (response) {
        return response.json();
      }).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(data) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  // Zeit merken, wann das Free Gift hinzugefügt wurde
                  sessionStorage.setItem('freeGiftTimestamp', Date.now().toString());
                  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true
                  }));

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }())["catch"](function (error) {
        console.log("Failed to add item to cart.");
      });
    }
  }]);

  return CartDrawerAutoFreeGift;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-drawer-auto-free-gift', CartDrawerAutoFreeGift);

/***/ }),

/***/ "./src/js/modules/ed-free-gift-handling.js":
/*!*************************************************!*\
  !*** ./src/js/modules/ed-free-gift-handling.js ***!
  \*************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var FreeGiftHandling = /*#__PURE__*/function (_HTMLElement) {
  _inherits(FreeGiftHandling, _HTMLElement);

  var _super = _createSuper(FreeGiftHandling);

  function FreeGiftHandling() {
    _classCallCheck(this, FreeGiftHandling);

    return _super.apply(this, arguments);
  }

  _createClass(FreeGiftHandling, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.isGiftAlreadyInCart = this.getAttribute('gift-already-in-cart');

      if (!sessionStorage.getItem('ed_free_gift_added') && !this.isGiftAlreadyInCart) {
        this._attachListeners();

        this._attachSelectors();
      } else {
        console.log('Cart threshold is not reached for free gift');
      }
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.cartTotal = this.getAttribute('cart-total');
      this.threshold = this.getAttribute('threshold');
      this.freeGiftItems = this.getAttribute('free-gift-ids');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('DOMContentLoaded', this.initFreeGifts.bind(this));
    }
  }, {
    key: "initFreeGifts",
    value: function initFreeGifts() {
      var isThresholdReached = this.isThresholdReached(this.cartTotal, this.threshold);

      if (!isThresholdReached) {
        return;
      }

      this.addFreeGifts(this.freeGiftItems);
    }
  }, {
    key: "isThresholdReached",
    value: function isThresholdReached(cartTotal, threshold) {
      return parseInt(cartTotal) >= parseInt(threshold);
    }
  }, {
    key: "addFreeGifts",
    value: function addFreeGifts(items) {
      var _this = this;

      var itemIds = items.split(',');
      var itemAdd = [];
      itemIds.forEach(function (id) {
        var item = {
          id: id,
          quantity: 1,
          properties: {
            '_free-gift': true
          }
        };
        itemAdd.push(item);
      });
      var formData = {
        'items': itemAdd,
        quantity: 1
      };
      fetch("/cart/add.js", {
        body: JSON.stringify(formData),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function () {
        _this.setSessionStorageItem('ed_free_gift_added', 'true');

        location.reload();
      })["catch"](function (e) {
        console.error(e);
      });
    }
  }, {
    key: "setSessionStorageItem",
    value: function setSessionStorageItem(key, value) {
      sessionStorage.setItem(key, value);
    }
  }]);

  return FreeGiftHandling;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-free-gift-handling', FreeGiftHandling);

/***/ }),

/***/ "./src/js/modules/ed-mega-menu.js":
/*!****************************************!*\
  !*** ./src/js/modules/ed-mega-menu.js ***!
  \****************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var MegaMenu = /*#__PURE__*/function (_HTMLElement) {
  _inherits(MegaMenu, _HTMLElement);

  var _super = _createSuper(MegaMenu);

  function MegaMenu() {
    _classCallCheck(this, MegaMenu);

    return _super.apply(this, arguments);
  }

  _createClass(MegaMenu, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners(); // set first sub category active


      this.currentSubCategory.classList.add('active');
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.itemsWithSubLinks = this.querySelectorAll('.mega-menu-link-item.w-sub-links');
      this.currentItemWithSubLinks = this.querySelector('.mega-menu-link-item.w-sub-links');
      this.subCategories = this.querySelectorAll('.mega-menu-middle-container .sub-category-container');
      this.currentSubCategory = this.querySelector('.mega-menu-middle-container .sub-category-container'); // preview hanlding

      this.previewItemTogglers = this.querySelectorAll('.mega-menu-link-item[data-preview-name]');
      this.previewItems = this.querySelectorAll('.preview-item[data-preview-name]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;

      this.itemsWithSubLinks.forEach(function (item) {
        item.addEventListener('click', _this.onToggleItem.bind(_this));
      });
      this.previewItemTogglers.forEach(function (item) {
        item.addEventListener('mouseover', _this.onTogglePreview.bind(_this));
      });
    }
  }, {
    key: "onToggleItem",
    value: function onToggleItem(e) {
      var _this2 = this;

      // toggles the sub links of an item
      e.preventDefault();
      var targetElement = e.target;

      if (this.currentItemWithSubLinks) {
        this.currentItemWithSubLinks.classList.remove('active');
      }

      this.subCategories.forEach(function (item) {
        if (targetElement.dataset.handle === item.dataset.handle) {
          item.classList.add('active');
          targetElement.classList.add('active');
          _this2.currentSubCategory = item;
          _this2.currentItemWithSubLinks = targetElement;
        } else {
          item.classList.remove('active');
        }
      });
    }
  }, {
    key: "onTogglePreview",
    value: function onTogglePreview(e) {
      var _this3 = this;

      var previewName = e.target.dataset.previewName;
      this.previewItems.forEach(function (item) {
        if (item.dataset.previewName === previewName) {
          // hide all other elements
          _this3.previewItems.forEach(function (item) {
            item.classList.remove('active');
          });

          item.classList.add('active');
          _this3.currentPreviewItem = item;
        }
      });
    }
  }]);

  return MegaMenu;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-mega-menu', MegaMenu);

/***/ }),

/***/ "./src/js/modules/ed-multi-column-slider.js":
/*!**************************************************!*\
  !*** ./src/js/modules/ed-multi-column-slider.js ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var sliders = document.querySelectorAll('.ed-multi-column--slider');

var Flick2 = __webpack_require__(/*! flickity */ "./node_modules/flickity/js/index.js");

var initialWidth = window.innerWidth;

function sliderInit(slider, sliderInstance) {
  if (sliderInstance) {
    sliderInstance.destroy();
  }

  sliderInstance = new Flick2(slider, {
    prevNextButtons: true,
    wrapAround: true,
    pageDots: false,
    cellAlign: 'center',
    arrowShape: {
      x0: 10,
      x1: 60,
      y1: 50,
      x2: 65,
      y2: 45,
      x3: 20
    }
  });
}

if (sliders) {
  sliders.forEach(function (slider, i) {
    var sliderInstance = null;
    sliderInit(slider, sliderInstance);
    window.addEventListener('resize', function () {
      if (slider) {
        var currentWidth = window.innerWidth;

        if (Math.abs(currentWidth - initialWidth) > 200) {
          sliderInit(slider, sliderInstance);
          initialWidth = currentWidth;
        }
      }
    });
  });
}

/***/ }),

/***/ "./src/js/modules/simple-bundle-template.js":
/*!**************************************************!*\
  !*** ./src/js/modules/simple-bundle-template.js ***!
  \**************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var SimpleBundleForm = /*#__PURE__*/function (_HTMLElement) {
  _inherits(SimpleBundleForm, _HTMLElement);

  var _super = _createSuper(SimpleBundleForm);

  function SimpleBundleForm() {
    _classCallCheck(this, SimpleBundleForm);

    return _super.apply(this, arguments);
  }

  _createClass(SimpleBundleForm, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners(); // set up bundle initially, needed for bundles without variant selectors


      this.onBundleChange();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.selectedItems = this.querySelectorAll('ed-simple-bundle-item, ed-bundle-item-selector'); /// todo: item without options

      this.btnSubmit = this.querySelector('.btn-bundle-submit');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('ed:bd:item-select', this.onBundleChange.bind(this));
      this.btnSubmit.addEventListener('click', this.onBtnSubmit.bind(this));
    }
  }, {
    key: "onBundleChange",
    value: function onBundleChange() {
      var _this = this;

      this.selectedItems = this.querySelectorAll('ed-simple-bundle-item, ed-bundle-item-selector');
      this.currentPrice = 0;
      this.currentComparePrice = 0;
      this.selectedVariantIds = [];
      this.selectedItems.forEach(function (item, index) {
        /** PRICE **/
        var selectedPrice = item.getAttribute('selected-price');

        if (selectedPrice !== '' && selectedPrice !== null && selectedPrice !== "undefined") {
          _this.currentPrice = _this.currentComparePrice + parseInt(selectedPrice);
        }
        /** COMPARE PRICE **/


        var selectedComparePrice = item.getAttribute('selected-compare-price');

        if (selectedComparePrice !== '' && selectedComparePrice !== null && selectedComparePrice !== "undefined") {
          _this.currentComparePrice += parseInt(selectedComparePrice);
        } else if (selectedPrice !== '' && selectedPrice !== null && selectedPrice !== "undefined") {
          // if no compare price in 1 item, still use the normal price // TODO
          _this.currentComparePrice += parseInt(selectedPrice);
        }
        /** VARIANT IDS **/


        var selectedVariantId = item.getAttribute('selected-variant-id');

        if (selectedVariantId !== '' && selectedVariantId !== null && selectedVariantId !== "undefined") {
          _this.selectedVariantIds.push(selectedVariantId);
        }
        /** THUMBNAIL **/
        // todo: mode thumbnail

        /**
         let selectedThumbnail = item.getAttribute('selected-thumbnail');
         if (selectedThumbnail !== '' && selectedThumbnail !== null && selectedThumbnail !== "undefined") {
            let thumbnail = this.querySelector('.bundle-item-thumbnail[data-index="' + index + '"]');
            thumbnail.style.backgroundImage = 'url("' + selectedThumbnail + '")';
        } else {
            let thumbnail = this.querySelector('.bundle-item-thumbnail[data-index="' + index + '"]');
            thumbnail.style.backgroundImage = '';
            thumbnail.style.backgroundColor  = 'white';
            // load default;
        }
         **/

      });
    }
  }, {
    key: "validateBundle",
    value: function validateBundle() {
      var isValid = true;
      this.querySelectorAll('ed-bundle-item-selector').forEach(function (item) {
        var variantId = item.getAttribute('selected-variant-id');

        if (variantId === '' || variantId === null || variantId === "undefined") {
          isValid = false;
        }
      });
      return isValid !== false;
    }
  }, {
    key: "onBtnSubmit",
    value: function onBtnSubmit() {
      if (!this.validateBundle()) {
        alert('Bitte wählen Sie eine Variante aus, um das Bundle in den Warenkorb hinzuzufügen.');
        return;
      }

      this.addBundleToCart();
    }
  }, {
    key: "addBundleToCart",
    value: function addBundleToCart() {
      var _this2 = this;

      this.btnSubmit.setAttribute('ed-loading', 'true');
      var items = [];
      this.selectedVariantIds.forEach(function (id) {
        items.push({
          id: id,
          quantity: 1,
          properties: {
            '_bundleItem': true,
            '_bundle': '{{ product.title }}',
            '_bundleUrl': '{{ product.url }}'
          }
        });
      });
      var formData = {
        'items': items
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then(function (response) {
        //this.onAddToCart();
        _this2.btnSubmit.removeAttribute('ed-loading');

        window.location.href = '/cart';
        return response.json();
      })["catch"](function (error) {
        _this2.btnSubmit.removeAttribute('ed-loading');

        console.error('Error:', error);
      });
    }
  }]);

  return SimpleBundleForm;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-simple-bundle-form', SimpleBundleForm);

var BundleItemSelector = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(BundleItemSelector, _HTMLElement2);

  var _super2 = _createSuper(BundleItemSelector);

  function BundleItemSelector() {
    _classCallCheck(this, BundleItemSelector);

    return _super2.apply(this, arguments);
  }

  _createClass(BundleItemSelector, [{
    key: "selectedVariantId",
    set:
    /** GETTERS AND SETTERS **/
    function set(value) {
      return this.setAttribute('selected-variant-id', value);
    }
  }, {
    key: "selectedComparePrice",
    set: function set(value) {
      return this.setAttribute('selected-compare-price', value);
    }
  }, {
    key: "selectedPrice",
    set: function set(value) {
      return this.setAttribute('selected-price', value);
    }
  }, {
    key: "selectedThumbnail",
    set: function set(value) {
      return this.setAttribute('selected-thumbnail', value);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.btnOpen = this.querySelector('.bundle-item-selector');
      this.dropdown = this.querySelector('.bundle-item-dropdown');
      this.selectedOptionText = this.querySelector('.selected-option');
      this.optionItems = this.dropdown.querySelectorAll('.item-option:not([disabled="true"])');
      this.clickOutsideOverlay = this.querySelector('.click-outside-overlay');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this3 = this;

      this.btnOpen.addEventListener('click', this.onBtnClick.bind(this));
      this.optionItems.forEach(function (item) {
        item.addEventListener('click', _this3.onOptionClick.bind(_this3));
      });
      this.clickOutsideOverlay.addEventListener('click', this.toggleDropdown.bind(this));
    }
  }, {
    key: "onBtnClick",
    value: function onBtnClick() {
      this.toggleDropdown();
    }
  }, {
    key: "toggleDropdown",
    value: function toggleDropdown() {
      this.dropdown.scrollTop = 0;
      this.classList.toggle('open');
    }
  }, {
    key: "onOptionClick",
    value: function onOptionClick(e) {
      var targetItem = e.target;
      this.selectedOptionText.innerText = targetItem.innerText;
      this.selectedPrice = targetItem.dataset.price;
      this.selectedComparePrice = targetItem.dataset.comparePrice;
      this.selectedVariantId = targetItem.dataset.variantId;
      this.selectedThumbnail = targetItem.dataset.thumbnail;
      this.toggleDropdown();
      document.dispatchEvent(new CustomEvent('ed:bd:item-select'));
    }
  }]);

  return BundleItemSelector;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-bundle-item-selector', BundleItemSelector);

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!**************************!*\
  !*** ./src/js/custom.js ***!
  \**************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules_simple_bundle_template__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modules/simple-bundle-template */ "./src/js/modules/simple-bundle-template.js");
/* harmony import */ var _modules_simple_bundle_template__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_modules_simple_bundle_template__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _modules_drawer_listener__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/drawer-listener */ "./src/js/modules/drawer-listener.js");
/* harmony import */ var _modules_drawer_listener__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_modules_drawer_listener__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _modules_ed_mega_menu__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./modules/ed-mega-menu */ "./src/js/modules/ed-mega-menu.js");
/* harmony import */ var _modules_ed_mega_menu__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_mega_menu__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _modules_ed_cart_upsell_items__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./modules/ed-cart-upsell-items */ "./src/js/modules/ed-cart-upsell-items.js");
/* harmony import */ var _modules_ed_cart_upsell_items__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_cart_upsell_items__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _modules_ed_free_gift_handling__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./modules/ed-free-gift-handling */ "./src/js/modules/ed-free-gift-handling.js");
/* harmony import */ var _modules_ed_free_gift_handling__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_free_gift_handling__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _modules_ed_multi_column_slider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./modules/ed-multi-column-slider */ "./src/js/modules/ed-multi-column-slider.js");
/* harmony import */ var _modules_ed_multi_column_slider__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_multi_column_slider__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _modules_ed_b2b_compare_price__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./modules/ed-b2b-compare-price */ "./src/js/modules/ed-b2b-compare-price.js");
/* harmony import */ var _modules_ed_b2b_compare_price__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_b2b_compare_price__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _modules_ed_drawer_free_gift__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./modules/ed-drawer-free-gift */ "./src/js/modules/ed-drawer-free-gift.js");
/* harmony import */ var _modules_ed_drawer_free_gift__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_drawer_free_gift__WEBPACK_IMPORTED_MODULE_7__);
/*
DO NOT TOUCH THIS FILE OUTSIDE OF /src DIRECTORY
this file gets compiled ./assets/custom.js - make sure to import every module here.
*/




 //import './modules/bundle-configurator';



 // REMOVE AFTER ED-469 TEST IS DONE

document.addEventListener('DOMContentLoaded', function () {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      attributes: {
        'ed-ab-ed-469': 'true'
      }
    })
  }).then(function (response) {
    return response.json();
  }).then(function (data) {
    console.log('Attributes:', data.attributes);
  })["catch"](function (error) {
    return console.error('❌ Error:', error);
  });
});
})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!******************************!*\
  !*** ./src/scss/custom.scss ***!
  \******************************/
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin

})();

/******/ })()
;